/*
@license
  Streamline by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use our custom event listeners to tap into common functions.
  Documentation - https://archetypethemes.co/blogs/streamline/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Stylesheet and theme scripts have loaded
  });
*/ (window.theme =
    window.theme || {}),
    (window.Shopify = window.Shopify || {}),
    (function () {
        var e = Flickity.prototype.resize,
            t = window.innerWidth;
        Flickity.prototype.resize = function () {
            window.innerWidth !== t && ((t = window.innerWidth), e.apply(this, arguments));
        };
    })(),
    (theme.bp = {}),
    (theme.config = {
        cssLoaded: !1,
        bpSmall: !1,
        hasSessionStorage: !0,
        mediaQuerySmall: "screen and (max-width: 768px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
        isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        rtl: "rtl" == document.documentElement.getAttribute("dir"),
    }),
    console && console.log && console.log("Streamline theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"),
    (window.lazySizesConfig = window.lazySizesConfig || {}),
    (lazySizesConfig.expFactor = 4),
    (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
    matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
        e.matches ? ((theme.config.bpSmall = !0), document.dispatchEvent(new CustomEvent("matchSmall"))) : ((theme.config.bpSmall = !1), document.dispatchEvent(new CustomEvent("unmatchSmall")));
    }),
    (function () {
        "use strict";
        var e, t, i, s, n, o, a;
        if (
            ((theme.delegate = {
                on: function (e, t, i) {
                    return this.namespaces || (this.namespaces = {}), (this.namespaces[e] = t), (i = i || !1), this.addEventListener(e.split(".")[0], t, i), this;
                },
                off: function (e) {
                    if (this.namespaces) return this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e], this;
                },
            }),
            (window.on = Element.prototype.on = theme.delegate.on),
            (window.off = Element.prototype.off = theme.delegate.off),
            (theme.utils = {
                defaultTo: function (e, t) {
                    return null == e || e != e ? t : e;
                },
                wrap: function (e, t) {
                    e.parentNode.insertBefore(t, e), t.appendChild(e);
                },
                debounce: function (e, t, i) {
                    var s;
                    return function () {
                        var n = this,
                            o = arguments,
                            a = i && !s;
                        clearTimeout(s),
                            (s = setTimeout(function () {
                                (s = null), i || t.apply(n, o);
                            }, e)),
                            a && t.apply(n, o);
                    };
                },
                throttle: function (e, t) {
                    var i = !1;
                    return function () {
                        i ||
                            (t.apply(this, arguments),
                            (i = !0),
                            setTimeout(function () {
                                i = !1;
                            }, e));
                    };
                },
                prepareTransition: function (e, t) {
                    e.addEventListener("transitionend", function t(i) {
                        e.classList.remove("is-transitioning"), e.removeEventListener("transitionend", t);
                    }),
                        e.classList.add("is-transitioning"),
                        e.offsetWidth,
                        "function" == typeof t && t();
                },
                compact: function (e) {
                    for (var t = -1, i = null == e ? 0 : e.length, s = 0, n = []; ++t < i; ) {
                        var o = e[t];
                        o && (n[s++] = o);
                    }
                    return n;
                },
                serialize: function (e) {
                    var t = [];
                    return (
                        Array.prototype.slice.call(e.elements).forEach(function (i) {
                            if (!(!i.name || i.disabled || ["file", "reset", "submit", "button"].indexOf(i.type) > -1)) {
                                if ("select-multiple" !== i.type) {
                                    if (!(["checkbox", "radio"].indexOf(i.type) > -1) || i.checked) {
                                        if (i.hasAttribute("data-property-index")) {
                                            let s = e.elements.id.selectedIndex;
                                            if (parseInt(i.dataset.propertyIndex, 10) !== s) return;
                                        }
                                        t.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(i.value));
                                    }
                                } else
                                    Array.prototype.slice.call(i.options).forEach(function (e) {
                                        e.selected && t.push(encodeURIComponent(i.name) + "=" + encodeURIComponent(e.value));
                                    });
                            }
                        }),
                        t.join("&")
                    );
                },
            }),
            (theme.a11y = {
                trapFocus: function (e) {
                    var t = { focusin: e.namespace ? "focusin." + e.namespace : "focusin", focusout: e.namespace ? "focusout." + e.namespace : "focusout", keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus" },
                        i = e.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'),
                        s = [].slice.call(i).filter((e) => null !== e.offsetParent),
                        n = s[0],
                        o = s[s.length - 1];
                    e.elementToFocus || (e.elementToFocus = e.container),
                        e.container.setAttribute("tabindex", "-1"),
                        e.elementToFocus.focus(),
                        document.documentElement.off("focusin"),
                        document.documentElement.on(t.focusout, function () {
                            document.documentElement.off(t.keydown);
                        }),
                        document.documentElement.on(t.focusin, function (e) {
                            (e.target !== o && e.target !== n) ||
                                document.documentElement.on(t.keydown, function (e) {
                                    var t;
                                    9 === (t = e).keyCode && t.target === n && t.shiftKey && (t.preventDefault(), o.focus());
                                });
                        });
                },
                removeTrapFocus: function (e) {
                    var t = e.namespace ? "focusin." + e.namespace : "focusin";
                    e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t);
                },
                lockMobileScrolling: function (e, t) {
                    var i = t || document.documentElement;
                    document.documentElement.classList.add("lock-scroll"),
                        i.on("touchmove" + e, function () {
                            return !0;
                        });
                },
                unlockMobileScrolling: function (e, t) {
                    document.documentElement.classList.remove("lock-scroll"), (t || document.documentElement).off("touchmove" + e);
                },
            }),
            document.documentElement.on("keyup.tab", function (e) {
                9 === e.keyCode && (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"));
            }),
            (theme.Sections = function () {
                (this.constructors = {}),
                    (this.instances = []),
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                    document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
                _createInstance: function (e, t, i) {
                    var s = e.getAttribute("data-section-id"),
                        n = e.getAttribute("data-section-type");
                    if (void 0 !== (t = t || this.constructors[n])) {
                        i && this._findInstance(s) && this._removeInstance(s);
                        var o = Object.assign(new t(e), { id: s, type: n, container: e });
                        this.instances.push(o);
                    }
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++) if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                _onSectionLoad: function (e, t, i) {
                    window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                    var s = t || e.target,
                        n = t || e.target.querySelector("[data-section-id]");
                    if (n) {
                        this._createInstance(n);
                        var o = t ? i : this._findInstance(e.detail.sectionId);
                        s.querySelectorAll("[data-subsection]").length && this.loadSubSections(s),
                            o && "function" == typeof o.onLoad && o.onLoad(e),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("scroll"));
                            }, 200);
                    }
                },
                _onSectionUnload: function (e) {
                    this.instances = this.instances.filter(function (t) {
                        var i = t.id === e.detail.sectionId;
                        return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
                    });
                },
                loadSubSections: function (e) {
                    e &&
                        e.querySelectorAll("[data-section-id]").forEach((e) => {
                            this._onSectionLoad(null, e, e.dataset.sectionId);
                        });
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                register: function (e, t, i) {
                    this.constructors[e] = t;
                    var s = document.querySelectorAll('[data-section-type="' + e + '"]');
                    i && (s = i.querySelectorAll('[data-section-type="' + e + '"]')),
                        s.forEach(
                            function (e) {
                                this._createInstance(e, t, i);
                            }.bind(this)
                        );
                },
                reinit: function (e) {
                    for (var t = 0; t < this.instances.length; t++) {
                        var i = this.instances[t];
                        i.type === e && "function" == typeof i.forceReload && i.forceReload();
                    }
                },
            })),
            (theme.Currency =
                ((e = theme && theme.settings && theme.settings.superScriptPrice),
                {
                    formatMoney: function (t, i) {
                        i || (i = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
                        var s = "",
                            n = /\{\{\s*(\w+)\s*\}\}/,
                            o = i || "${{amount}}";
                        function a(e, t, i, s) {
                            if (((t = theme.utils.defaultTo(t, 2)), (i = theme.utils.defaultTo(i, ",")), (s = theme.utils.defaultTo(s, ".")), isNaN(e) || null == e)) return 0;
                            var n = (e = (e / 100).toFixed(t)).split(".");
                            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "");
                        }
                        switch (o.match(n)[1]) {
                            case "amount":
                                (s = a(t, 2)), e && s && s.includes(".") && (s = s.replace(".", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals":
                                s = a(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                (s = a(t, 2, ".", ",")), e && s && s.includes(".") && (s = s.replace(",", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                s = a(t, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                s = a(t, 0, " ");
                        }
                        return o.replace(n, s);
                    },
                    getBaseUnit: function (e) {
                        if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value)
                            return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                    },
                })),
            (theme.Images = {
                imageSize: function (e) {
                    if (!e) return "620x";
                    var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return null !== t ? t[1] : null;
                },
                getSizedImageUrl: function (e, t) {
                    if (!e || null == t) return e;
                    if ("master" === t) return this.removeProtocol(e);
                    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != i) {
                        var s = e.split(i[0]),
                            n = i[0];
                        return this.removeProtocol(s[0] + "_" + t + n);
                    }
                    return null;
                },
                removeProtocol: function (e) {
                    return e.replace(/http(s)?:/, "");
                },
                lazyloadImagePath: function (e) {
                    var t;
                    return null !== e && (t = e.replace(/(\.[^.]*)$/, "_{width}x$1")), t;
                },
            }),
            (theme.loadImageSection = function (e) {
                function t() {
                    e.classList.remove("loading", "loading--delayed"), e.classList.add("loaded");
                }
                function i() {
                    return e.querySelector(".lazyloaded");
                }
                if (e.querySelector("svg")) t();
                else if (i()) t();
                else
                    var s = setInterval(function () {
                        i() && (clearInterval(s), t());
                    }, 25);
            }),
            (theme.initWhenVisible = function (e) {
                var t = e.threshold ? e.threshold : 0;
                new IntersectionObserver(
                    (t, i) => {
                        t.forEach((t) => {
                            t.isIntersecting && "function" == typeof e.callback && (e.callback(), i.unobserve(t.target));
                        });
                    },
                    { rootMargin: "0px 0px " + t + "px 0px" }
                ).observe(e.element);
            }),
            (theme.Variants = (function () {
                function e(e) {
                    (this.container = e.container),
                        (this.variants = e.variants),
                        (this.singleOptionSelector = e.singleOptionSelector),
                        (this.originalSelectorId = e.originalSelectorId),
                        (this.enableHistoryState = e.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        this.container.querySelectorAll(this.singleOptionSelector).forEach((e) => {
                            e.addEventListener("change", this._onSelectChange.bind(this));
                        });
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        _getCurrentOptions: function () {
                            var e = [];
                            return (
                                this.container.querySelectorAll(this.singleOptionSelector).forEach((t) => {
                                    var i = t.getAttribute("type");
                                    "radio" === i || "checkbox" === i ? t.checked && e.push({ value: t.value, index: t.dataset.index }) : e.push({ value: t.value, index: t.dataset.index });
                                }),
                                (e = theme.utils.compact(e))
                            );
                        },
                        _getVariantFromOptions: function () {
                            var e = this._getCurrentOptions(),
                                t = this.variants,
                                i = !1;
                            return (
                                t.forEach(function (t) {
                                    var s = !0;
                                    t.options,
                                        e.forEach(function (e) {
                                            s && (s = t[e.index] === e.value);
                                        }),
                                        s && (i = t);
                                }),
                                i || null
                            );
                        },
                        _onSelectChange: function () {
                            var e = this._getVariantFromOptions();
                            this.container.dispatchEvent(new CustomEvent("variantChange", { detail: { variant: e } })),
                                document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: e } })),
                                e &&
                                    (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateUnitPrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                        },
                        _updateImages: function (e) {
                            var t = e.featured_image || {},
                                i = this.currentVariant.featured_image || {};
                            e.featured_image && t.src !== i.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", { detail: { variant: e } }));
                        },
                        _updatePrice: function (e) {
                            (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) || this.container.dispatchEvent(new CustomEvent("variantPriceChange", { detail: { variant: e } }));
                        },
                        _updateUnitPrice: function (e) {
                            e.unit_price !== this.currentVariant.unit_price && this.container.dispatchEvent(new CustomEvent("variantUnitPriceChange", { detail: { variant: e } }));
                        },
                        _updateSKU: function (e) {
                            e.sku !== this.currentVariant.sku && this.container.dispatchEvent(new CustomEvent("variantSKUChange", { detail: { variant: e } }));
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (e) {
                            (this.container.querySelector(this.originalSelectorId).value = e.id), this.container.querySelector(this.originalSelectorId).dispatchEvent(new Event("change", { bubbles: !0 }));
                        },
                    })),
                    e
                );
            })()),
            (theme.rteInit = function () {
                function e(e) {
                    e.src = e.src;
                    var t = document.createElement("div");
                    t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
                }
                document.querySelectorAll(".rte table").forEach((e) => {
                    var t = document.createElement("div");
                    t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
                }),
                    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll(".rte a img").forEach((e) => {
                        e.parentNode.classList.add("rte__image");
                    });
            }),
            (theme.LibraryLoader =
                ((s = { requested: "requested", loaded: "loaded" }),
                (o = {
                    youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: (i = "script") },
                    vimeo: { tagId: "vimeo-api", src: "https://player.vimeo.com/api/player.js", type: i },
                    shopifyXr: { tagId: "shopify-model-viewer-xr", src: (n = "https://cdn.shopify.com/shopifycloud/") + "shopify-xr-js/assets/v1.0/shopify-xr.en.js", type: i },
                    modelViewerUi: { tagId: "shopify-model-viewer-ui", src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js", type: i },
                    modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: (t = "link") },
                }),
                {
                    load: function (e, n) {
                        var a = o[e];
                        if (a && a.status !== s.requested) {
                            if (((n = n || function () {}), a.status !== s.loaded)) {
                                switch (((a.status = s.requested), a.type)) {
                                    case i:
                                        p =
                                            ((r = a),
                                            (c = n),
                                            ((l = document.createElement("script")).src = r.src),
                                            l.addEventListener("load", function () {
                                                (r.status = s.loaded), c();
                                            }),
                                            l);
                                        break;
                                    case t:
                                        p =
                                            ((d = a),
                                            (h = n),
                                            ((u = document.createElement("link")).href = d.src),
                                            (u.rel = "stylesheet"),
                                            (u.type = "text/css"),
                                            u.addEventListener("load", function () {
                                                (d.status = s.loaded), h();
                                            }),
                                            u);
                                }
                                (p.id = a.tagId), (a.element = p);
                                var r,
                                    c,
                                    l,
                                    d,
                                    h,
                                    u,
                                    p,
                                    f = document.getElementsByTagName(a.type)[0];
                                f.parentNode.insertBefore(p, f);
                            } else n();
                        }
                    },
                })),
            (window.vimeoApiReady = function () {
                var e, t;
                (theme.config.vimeoLoading = !0),
                    new Promise((i, s) => {
                        (e = setInterval(function () {
                            Vimeo && (clearInterval(e), clearTimeout(t), i());
                        }, 500)),
                            (t = setTimeout(function () {
                                clearInterval(e), s();
                            }, 4e3));
                    }).then(function () {
                        (theme.config.vimeoReady = !0), (theme.config.vimeoLoading = !1), document.dispatchEvent(new CustomEvent("vimeoReady"));
                    });
            }),
            (theme.VimeoPlayer = (function () {
                var e = "loading",
                    t = { background: !0, byline: !1, controls: !1, loop: !0, muted: !0, playsinline: !0, portrait: !1, title: !1 };
                function i(e, t, i) {
                    (this.divId = e),
                        (this.el = document.getElementById(e)),
                        (this.videoId = t),
                        (this.iframe = null),
                        (this.options = i),
                        this.options && this.options.videoParent && (this.parent = this.el.closest(this.options.videoParent)),
                        this.setAsLoading(),
                        theme.config.vimeoReady ? this.init() : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady), document.addEventListener("vimeoReady", this.init.bind(this)));
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            var e = t;
                            (e.id = this.videoId), (this.videoPlayer = new Vimeo.Player(this.el, e)), this.videoPlayer.ready().then(this.playerReady.bind(this));
                        },
                        playerReady: function () {
                            (this.iframe = this.el.querySelector("iframe")),
                                this.iframe.setAttribute("tabindex", "-1"),
                                this.videoPlayer.setMuted(!0),
                                this.setAsLoaded(),
                                new IntersectionObserver(
                                    (e, t) => {
                                        e.forEach((e) => {
                                            e.isIntersecting ? this.play() : this.pause();
                                        });
                                    },
                                    { rootMargin: "0px 0px 50px 0px" }
                                ).observe(this.iframe);
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e);
                        },
                        setAsLoaded: function () {
                            this.parent && (this.parent.classList.remove(e), this.parent.classList.add("loaded"), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add("video-interactable");
                        },
                        play: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play();
                        },
                        pause: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause();
                        },
                        destroy: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy();
                        },
                    })),
                    i
                );
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), document.dispatchEvent(new CustomEvent("youTubeReady"));
            }),
            (theme.YouTube = (function () {
                var e = "loading",
                    t = { width: 1280, height: 720, playerVars: { autohide: 0, autoplay: 1, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, rel: 0 } };
                function i(e, i) {
                    (this.divId = e),
                        (this.iframe = null),
                        (this.attemptedToPlay = !1),
                        (t.events = { onReady: this.onVideoPlayerReady.bind(this), onStateChange: this.onVideoStateChange.bind(this) }),
                        (this.options = Object.assign({}, t, i)),
                        this.options &&
                            (this.options.videoParent && (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)),
                            this.options.autoplay || (this.options.playerVars.autoplay = this.options.autoplay),
                            "sound" === this.options.style && ((this.options.playerVars.controls = 1), (this.options.playerVars.autoplay = 0))),
                        this.setAsLoading(),
                        theme.config.youTubeReady ? this.init() : (theme.LibraryLoader.load("youtubeSdk"), document.addEventListener("youTubeReady", this.init.bind(this)));
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            this.videoPlayer = new YT.Player(this.divId, this.options);
                        },
                        onVideoPlayerReady: function (e) {
                            (this.iframe = document.getElementById(this.divId)),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "sound" !== this.options.style && e.target.mute(),
                                new IntersectionObserver(
                                    (e, t) => {
                                        e.forEach((e) => {
                                            e.isIntersecting ? this.play() : this.pause();
                                        });
                                    },
                                    { rootMargin: "0px 0px 50px 0px" }
                                ).observe(this.iframe);
                        },
                        onVideoStateChange: function (e) {
                            switch (e.data) {
                                case -1:
                                    this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                                    break;
                                case 0:
                                    this.play(e);
                                    break;
                                case 1:
                                    this.setAsLoaded();
                                    break;
                                case 3:
                                    this.attemptedToPlay = !0;
                            }
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e);
                        },
                        setAsLoaded: function () {
                            this.parent && (this.parent.classList.remove(e), this.parent.classList.add("loaded"), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add("video-interactable");
                        },
                        play: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.playVideo && this.videoPlayer.playVideo();
                        },
                        pause: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.pauseVideo && this.videoPlayer.pauseVideo();
                        },
                        destroy: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy();
                        },
                    })),
                    i
                );
            })()),
            (theme.AjaxRenderer = (function () {
                function e({ sections: e, preserveParams: t, onReplace: i, debug: s } = {}) {
                    (this.sections = e || []), (this.preserveParams = t || []), (this.cachedSections = []), (this.onReplace = i), (this.debug = Boolean(s));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        renderPage: function (e, t, i = !0) {
                            t && this.appendPreservedParams(t);
                            let s = this.sections.map((i) => {
                                let s = `${e}?section_id=${i.sectionId}&${t}`,
                                    n = (e) => e.url === s;
                                return this.cachedSections.some(n) ? this.renderSectionFromCache(n, i) : this.renderSectionFromFetch(s, i);
                            });
                            return i && this.updateURLHash(t), Promise.all(s);
                        },
                        renderSectionFromCache: function (e, t) {
                            let i = this.cachedSections.find(e);
                            return this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`), this.renderSection(i.html, t), Promise.resolve(t);
                        },
                        renderSectionFromFetch: function (e, t) {
                            return (
                                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                                new Promise((i, s) => {
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((s) => {
                                            let n = s;
                                            (this.cachedSections = [...this.cachedSections, { html: n, url: e }]), this.renderSection(n, t), i(t);
                                        })
                                        .catch((e) => s(e));
                                })
                            );
                        },
                        renderSection: function (e, t) {
                            this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`);
                            let i = new DOMParser().parseFromString(e, "text/html");
                            return (
                                this.onReplace
                                    ? this.onReplace(i, t)
                                    : "string" == typeof t.nodeId
                                    ? (document.getElementById(t.nodeId).innerHTML = i.getElementById(t.nodeId).innerHTML)
                                    : t.nodeId.forEach((e) => {
                                          document.getElementById(e).innerHTML = i.getElementById(e).innerHTML;
                                      }),
                                t
                            );
                        },
                        appendPreservedParams: function (e) {
                            this.preserveParams.forEach((t) => {
                                let i = new URLSearchParams(window.location.search).get(t);
                                i && (this.log(`[AjaxRenderer] Preserving ${t} param`), e.append(t, i));
                            });
                        },
                        updateURLHash: function (e) {
                            history.pushState({}, "", `${window.location.pathname}${e && "?".concat(e)}`);
                        },
                        log: function (...e) {
                            this.debug && console.log(...e);
                        },
                    })),
                    e
                );
            })()),
            (theme.cart = {
                getCart: function () {
                    return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), { credentials: "same-origin", method: "GET" }).then((e) => e.json());
                },
                getCartProductMarkup: function () {
                    var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
                    return fetch((e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"), { credentials: "same-origin", method: "GET" }).then(function (e) {
                        return e.text();
                    });
                },
                changeItem: function (e, t) {
                    return this._updateCart({ url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()), data: JSON.stringify({ id: e, quantity: t }) });
                },
                _updateCart: function (e) {
                    return fetch(e.url, { method: "POST", body: e.data, credentials: "same-origin", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" } })
                        .then((e) => e.json())
                        .then(function (e) {
                            return e;
                        });
                },
                updateAttribute: function (e, t) {
                    return this._updateCart({ url: "/cart/update.js", data: JSON.stringify({ attributes: { [e]: theme.cart.attributeToString(t) } }) });
                },
                updateNote: function (e) {
                    return this._updateCart({ url: "/cart/update.js", data: JSON.stringify({ note: theme.cart.attributeToString(e) }) });
                },
                attributeToString: function (e) {
                    return "string" != typeof e && "undefined" == (e += "") && (e = ""), e.trim();
                },
            }),
            (theme.CartForm = (function () {
                var e = "[data-subtotal]",
                    t = "btn--loading",
                    i = { requiresTerms: !1 };
                function s(t) {
                    t &&
                        ((this.form = t),
                        (this.wrapper = t.parentNode),
                        (this.location = t.dataset.location),
                        (this.namespace = ".cart-" + this.location),
                        (this.products = t.querySelector("[data-products]")),
                        (this.submitBtn = t.querySelector(".cart__checkout")),
                        (this.discounts = t.querySelector("[data-discounts]")),
                        (this.savings = t.querySelector("[data-savings]")),
                        (this.subtotal = t.querySelector(e)),
                        (this.termsCheckbox = t.querySelector(".cart__terms-checkbox")),
                        (this.noteInput = t.querySelector('[name="note"]')),
                        this.termsCheckbox && (i.requiresTerms = !0),
                        this.init());
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        init: function () {
                            this.initQtySelectors(),
                                document.addEventListener("cart:quantity" + this.namespace, this.quantityChanged.bind(this)),
                                this.form.on("submit" + this.namespace, this.onSubmit.bind(this)),
                                this.noteInput &&
                                    this.noteInput.addEventListener("change", function () {
                                        var e = this.value;
                                        theme.cart.updateNote(e);
                                    }),
                                document.addEventListener(
                                    "cart:build",
                                    function () {
                                        this.buildCart();
                                    }.bind(this)
                                );
                        },
                        reInit: function () {
                            this.initQtySelectors();
                        },
                        onSubmit: function (e) {
                            if ((this.submitBtn.classList.add(t), i.requiresTerms && !this.termsCheckbox.checked)) return alert(theme.strings.cartTermsConfirmation), this.submitBtn.classList.remove(t), e.preventDefault(), !1;
                        },
                        _parseProductHTML: function (e) {
                            var t = new DOMParser().parseFromString(e, "text/html");
                            return { items: t.querySelector(".cart__items"), discounts: t.querySelector(".cart__discounts") };
                        },
                        buildCart: function () {
                            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
                        },
                        cartMarkup: function (e) {
                            var t = this._parseProductHTML(e),
                                i = t.items,
                                s = parseInt(i.dataset.count),
                                n = i.dataset.cartSubtotal,
                                o = i.dataset.cartSavings;
                            this.updateCartDiscounts(t.discounts),
                                this.updateSavings(o),
                                s > 0 ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty"),
                                this.updateCount(s),
                                (this.products.innerHTML = ""),
                                this.products.append(i),
                                (this.subtotal.innerHTML = theme.Currency.formatMoney(n, theme.settings.moneyFormat)),
                                this.reInit(),
                                window.AOS && AOS.refreshHard(),
                                Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize();
                        },
                        updateCartDiscounts: function (e) {
                            this.discounts && ((this.discounts.innerHTML = ""), this.discounts.append(e));
                        },
                        initQtySelectors: function () {
                            this.form.querySelectorAll(".js-qty__wrapper").forEach((e) => {
                                new theme.QtySelector(e, { namespace: this.namespace, isCart: !0 });
                            });
                        },
                        quantityChanged: function (e) {
                            var t = e.detail[0],
                                i = e.detail[1],
                                s = e.detail[2];
                            t &&
                                i &&
                                (s && s.classList.add("is-loading"),
                                theme.cart
                                    .changeItem(t, i)
                                    .then(
                                        function (e) {
                                            e.item_count > 0 ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty"),
                                                this.buildCart(),
                                                document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: e } }));
                                        }.bind(this)
                                    )
                                    .catch(function (e) {}));
                        },
                        updateSubtotal: function (t) {
                            this.form.querySelector(e).innerHTML = theme.Currency.formatMoney(t, theme.settings.moneyFormat);
                        },
                        updateSavings: function (e) {
                            if (this.savings) {
                                if (e > 0) {
                                    var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                                    this.savings.classList.remove("hide"), (this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", t));
                                } else this.savings.classList.add("hide");
                            }
                        },
                        updateCount: function (e) {
                            var t = document.querySelectorAll(".cart-link__bubble-num");
                            t.length &&
                                t.forEach((t) => {
                                    t.innerText = e;
                                });
                            var i = document.querySelectorAll(".cart-link__bubble");
                            i.length &&
                                (e > 0
                                    ? i.forEach((e) => {
                                          e.classList.add("cart-link__bubble--visible");
                                      })
                                    : i.forEach((e) => {
                                          e.classList.remove("cart-link__bubble--visible");
                                      }));
                        },
                    })),
                    s
                );
            })()),
            (theme.collapsibles = (function () {
                var e = { trigger: ".collapsible-trigger", module: ".collapsible-content", moduleInner: ".collapsible-content__inner", tabs: ".collapsible-trigger--tab" },
                    t = { hide: "hide", open: "is-open", autoHeight: "collapsible--auto-height", tabs: "collapsible-trigger--tab" },
                    i = ".collapsible",
                    s = !1;
                function n(n) {
                    if (!s) {
                        s = !0;
                        var a = n.currentTarget,
                            r = a.classList.contains(t.open),
                            c = a.classList.contains(t.tabs),
                            l = a.getAttribute("aria-controls"),
                            d = document.getElementById(l);
                        if ((l || (l = a.dataset.controls), l)) {
                            if ((!d && document.querySelectorAll('[data-id="' + l + '"]').length > 0 && (d = a.parentNode.querySelector('[data-id="' + l + '"]')), d)) {
                                var h = d.querySelector(e.moduleInner).offsetHeight,
                                    u = d.classList.contains(t.autoHeight),
                                    p = d.parentNode.closest(e.module),
                                    f = h;
                                if (c) {
                                    if (r) return void (s = !1);
                                    document.querySelectorAll(e.tabs + '[data-id="' + a.dataset.id + '"]').forEach((e) => {
                                        e.classList.remove(t.open), o(document.querySelector("#" + e.getAttribute("aria-controls")), 0, !0);
                                    });
                                }
                                if (
                                    (r &&
                                        u &&
                                        setTimeout(function () {
                                            o(d, (h = 0), r, u);
                                        }, 0),
                                    r && !u && (h = 0),
                                    a.setAttribute("aria-expanded", !r),
                                    r ? a.classList.remove(t.open) : a.classList.add(t.open),
                                    o(d, h, r, u),
                                    p && o(p, r ? p.offsetHeight - f : h + p.offsetHeight, !1, !1),
                                    window.SPR)
                                ) {
                                    var m = d.querySelector(".spr-summary-actions-newreview");
                                    if (!m) return;
                                    m.off("click" + i),
                                        m.on("click" + i, function () {
                                            (h = d.querySelector(e.moduleInner).offsetHeight), o(d, h, r, u);
                                        });
                                }
                            } else s = !1;
                        }
                    }
                }
                function o(e, i, n, o) {
                    if (
                        (e.classList.remove(t.hide),
                        theme.utils.prepareTransition(e, function () {
                            (e.style.height = i + "px"), n ? e.classList.remove(t.open) : e.classList.add(t.open);
                        }),
                        !n && o)
                    ) {
                        var a = e;
                        window.setTimeout(function () {
                            a.css("height", "auto"), (s = !1);
                        }, 500);
                    } else s = !1;
                }
                return {
                    init: function (s) {
                        (s || document).querySelectorAll(e.trigger).forEach((e) => {
                            var s = e.classList.contains(t.open);
                            e.setAttribute("aria-expanded", s), e.off("click" + i), e.on("click" + i, n);
                        });
                    },
                };
            })()),
            (theme.Disclosure = (function () {
                var e = "disclosure-list--visible";
                function t(e) {
                    (this.container = e), this._cacheSelectors(), this._setupListeners();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        _cacheSelectors: function () {
                            this.cache = {
                                disclosureForm: this.container.closest("[data-disclosure-form]"),
                                disclosureList: this.container.querySelector("[data-disclosure-list]"),
                                disclosureToggle: this.container.querySelector("[data-disclosure-toggle]"),
                                disclosureInput: this.container.querySelector("[data-disclosure-input]"),
                                disclosureOptions: this.container.querySelectorAll("[data-disclosure-option]"),
                            };
                        },
                        _setupListeners: function () {
                            (this.eventHandlers = this._setupEventHandlers()),
                                this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.addEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                                this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                                document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                        },
                        _setupEventHandlers: function () {
                            return {
                                connectOptions: this._connectOptions.bind(this),
                                toggleList: this._toggleList.bind(this),
                                onBodyClick: this._onBodyClick.bind(this),
                                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                                onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                                onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                            };
                        },
                        _connectOptions: function (e) {
                            e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                        },
                        _onDisclosureToggleFocusOut: function (e) {
                            !1 === this.container.contains(e.relatedTarget) && this._hideList();
                        },
                        _onDisclosureListFocusOut: function (t) {
                            var i = t.currentTarget.contains(t.relatedTarget);
                            this.cache.disclosureList.classList.contains(e) && !i && this._hideList();
                        },
                        _onDisclosureKeyUp: function (e) {
                            27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                        },
                        _onBodyClick: function (t) {
                            var i = this.container.contains(t.target);
                            this.cache.disclosureList.classList.contains(e) && !i && this._hideList();
                        },
                        _submitForm: function (e) {
                            (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                        },
                        _hideList: function () {
                            this.cache.disclosureList.classList.remove(e), this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                        },
                        _toggleList: function () {
                            var t = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                            this.cache.disclosureList.classList.toggle(e), this.cache.disclosureToggle.setAttribute("aria-expanded", !t);
                        },
                        destroy: function () {
                            this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.removeEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                                this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                                document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                        },
                    })),
                    t
                );
            })()),
            (theme.Drawers = (function () {
                function e(e, t) {
                    (this.config = { id: e, close: ".js-drawer-close", open: ".js-drawer-open-" + t, openClass: "js-drawer-open", closingClass: "js-drawer-closing", activeDrawer: "drawer--is-open", namespace: ".drawer-" + t }),
                        (this.nodes = { page: document.querySelector("#MainContent") }),
                        (this.drawer = document.querySelector("#" + e)),
                        (this.isOpen = !1),
                        this.drawer && this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            document.querySelectorAll(this.config.open).forEach((e) => {
                                e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                            }),
                                this.drawer.querySelector(this.config.close).addEventListener("click", this.close.bind(this)),
                                document.addEventListener(
                                    "modalOpen",
                                    function () {
                                        this.close();
                                    }.bind(this)
                                );
                        },
                        open: function (e, t) {
                            scrollLock.disablePageScroll(),
                                e && (e.preventDefault(), e.currentTarget.classList.contains("js-drawer-open-cart") && document.dispatchEvent(new CustomEvent("cart:is-open"))),
                                this.isOpen ||
                                    (e && e.stopPropagation
                                        ? (e.stopPropagation(), e.currentTarget.setAttribute("aria-expanded", "true"), (this.activeSource = e.currentTarget))
                                        : t && (t.setAttribute("aria-expanded", "true"), (this.activeSource = t)),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.add(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.add(this.config.openClass),
                                    (this.isOpen = !0),
                                    theme.a11y.trapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    document.dispatchEvent(new CustomEvent("drawerOpen")),
                                    document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)),
                                    this.bindEvents());
                        },
                        close: function (e) {
                            if (this.isOpen) {
                                if (e) {
                                    if (e.target.closest(".js-drawer-close"));
                                    else if (e.target.closest(".drawer")) return;
                                }
                                document.activeElement.blur(),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.remove(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.remove(this.config.openClass),
                                    document.documentElement.classList.add(this.config.closingClass),
                                    window.setTimeout(
                                        function () {
                                            document.documentElement.classList.remove(this.config.closingClass),
                                                this.activeSource && this.activeSource.getAttribute("aria-expanded") && (this.activeSource.setAttribute("aria-expanded", "false"), this.activeSource.focus());
                                        }.bind(this),
                                        500
                                    ),
                                    (this.isOpen = !1),
                                    theme.a11y.removeTrapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    this.unbindEvents(),
                                    scrollLock.enablePageScroll();
                            }
                        },
                        bindEvents: function () {
                            window.on(
                                "click" + this.config.namespace,
                                function (e) {
                                    this.close(e);
                                }.bind(this)
                            ),
                                window.on(
                                    "keyup" + this.config.namespace,
                                    function (e) {
                                        27 === e.keyCode && this.close();
                                    }.bind(this)
                                ),
                                theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                        unbindEvents: function () {
                            window.off("click" + this.config.namespace), window.off("keyup" + this.config.namespace), theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                    })),
                    e
                );
            })()),
            (theme.Modals = (function () {
                function e(e, t, i) {
                    if ("search-modal" !== t) {
                        if (((this.id = e), (this.modal = document.getElementById(e)), !this.modal)) return !1;
                        (this.modalContent = this.modal.querySelector(".modal__inner")),
                            (this.config = Object.assign(
                                {
                                    close: ".js-modal-close",
                                    open: ".js-modal-open-" + t,
                                    openClass: "modal--is-active",
                                    closingClass: "modal--is-closing",
                                    bodyOpenClass: ["modal-open"],
                                    bodyOpenSolidClass: "modal-open--solid",
                                    bodyClosingClass: "modal-closing",
                                    closeOffContentClick: !0,
                                },
                                i
                            )),
                            (this.modalIsOpen = !1),
                            (this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal),
                            (this.isSolid = this.config.solid),
                            this.init();
                    }
                }
                return (
                    (e.prototype.init = function () {
                        document.querySelectorAll(this.config.open).forEach((e) => {
                            e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                        }),
                            this.modal.querySelectorAll(this.config.close).forEach((e) => {
                                e.addEventListener("click", this.close.bind(this));
                            }),
                            document.addEventListener(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (e.prototype.open = function (e) {
                        var t = !1;
                        this.modalIsOpen ||
                            (e ? e.preventDefault() : (t = !0),
                            e && e.stopPropagation && (e.stopPropagation(), (this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true"))),
                            this.modalIsOpen && !t && this.close(),
                            this.modal.classList.add(this.config.openClass),
                            document.documentElement.classList.add(...this.config.bodyOpenClass),
                            this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            theme.a11y.trapFocus({ container: this.modal, elementToFocus: this.focusOnOpen, namespace: "modal_focus" }),
                            document.dispatchEvent(new CustomEvent("modalOpen")),
                            document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
                            this.bindEvents());
                    }),
                    (e.prototype.close = function (e) {
                        if (this.modalIsOpen) {
                            if (e) {
                                if (e.target.closest(".js-modal-close"));
                                else if (e.target.closest(".modal__inner")) return;
                            }
                            document.activeElement.blur(),
                                this.modal.classList.remove(this.config.openClass),
                                this.modal.classList.add(this.config.closingClass),
                                document.documentElement.classList.remove(...this.config.bodyOpenClass),
                                document.documentElement.classList.add(this.config.bodyClosingClass),
                                window.setTimeout(
                                    function () {
                                        document.documentElement.classList.remove(this.config.bodyClosingClass),
                                            this.modal.classList.remove(this.config.closingClass),
                                            this.activeSource && this.activeSource.getAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "false").focus();
                                    }.bind(this),
                                    500
                                ),
                                this.isSolid && document.documentElement.classList.remove(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                theme.a11y.removeTrapFocus({ container: this.modal, namespace: "modal_focus" }),
                                document.dispatchEvent(new CustomEvent("modalClose." + this.id)),
                                this.unbindEvents();
                        }
                    }),
                    (e.prototype.bindEvents = function () {
                        window.on(
                            "keyup.modal",
                            function (e) {
                                27 === e.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this));
                    }),
                    (e.prototype.unbindEvents = function () {
                        document.documentElement.off(".modal"), this.config.closeOffContentClick && this.modal.off(".modal");
                    }),
                    e
                );
            })()),
            void 0 === window.noUiSlider)
        )
            throw Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        (theme.PriceRange = (function () {
            function e(e, { onChange: t, onUpdate: i, ...s } = {}) {
                return (this.container = e), (this.onChange = t), (this.onUpdate = i), (this.sliderOptions = s || {}), this.init();
            }
            return (
                (e.prototype = Object.assign({}, e.prototype, {
                    init: function () {
                        if (!this.container.classList.contains("price-range")) throw Error("You must instantiate PriceRange with a valid container");
                        return (
                            (this.formEl = this.container.closest("form")),
                            (this.sliderEl = this.container.querySelector(".price-range__slider")),
                            (this.inputMinEl = this.container.querySelector(".price-range__input-min")),
                            (this.inputMaxEl = this.container.querySelector(".price-range__input-max")),
                            (this.displayMinEl = this.container.querySelector(".price-range__display-min")),
                            (this.displayMaxEl = this.container.querySelector(".price-range__display-max")),
                            (this.minRange = parseFloat(this.container.dataset.min) || 0),
                            (this.minValue = parseFloat(this.container.dataset.minValue) || 0),
                            (this.maxRange = parseFloat(this.container.dataset.max) || 100),
                            (this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange),
                            this.createPriceRange()
                        );
                    },
                    createPriceRange: function () {
                        this.sliderEl && this.sliderEl.noUiSlider && "function" == typeof this.sliderEl.noUiSlider.destroy && this.sliderEl.noUiSlider.destroy();
                        var e = noUiSlider.create(this.sliderEl, { connect: !0, step: 10, ...this.sliderOptions, start: [this.minValue, this.maxValue], range: { min: this.minRange, max: this.maxRange } });
                        return (
                            e.on("update", (e) => {
                                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(e[0], theme.settings.moneyFormat)),
                                    (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(e[1], theme.settings.moneyFormat)),
                                    this.onUpdate && this.onUpdate(e);
                            }),
                            e.on("change", (e) => {
                                if ((console.log("change"), (this.inputMinEl.value = e[0]), (this.inputMaxEl.value = e[1]), this.onChange)) {
                                    let t = new FormData(this.formEl);
                                    this.onChange(t);
                                }
                            }),
                            e
                        );
                    },
                })),
                e
            );
        })()),
            (theme.AjaxProduct = (function () {
                var e = { loading: !1 };
                function t(e, t, i) {
                    (this.form = e), (this.args = i), this.form && ((this.addToCart = e.querySelector(t || ".add-to-cart")), this.form.addEventListener("submit", this.addItemFromForm.bind(this)));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        addItemFromForm: function (t, i) {
                            t.preventDefault();
                            let s = !1,
                                n = { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" };
                            if ((this.form.classList.contains("js-bundle-form") && ((s = !0), (n = { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" })), !e.loading)) {
                                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                                var o = s ? JSON.stringify(window.bundle) : theme.utils.serialize(this.form);
                                fetch(theme.routes.cartAdd, { method: "POST", body: o, credentials: "same-origin", headers: n })
                                    .then((e) => e.json())
                                    .then(
                                        function (t) {
                                            422 === t.status
                                                ? (this.error(t),
                                                  s &&
                                                      (console.log(t.description),
                                                      (document.getElementById("product-sold-out-alert").innerHTML = theme.strings.bundleError422),
                                                      document.getElementById("popupWrapper").classList.remove("hidden")))
                                                : (this.success(t), s && document.dispatchEvent(new CustomEvent("cart:bundle-updated"))),
                                                (e.loading = !1),
                                                this.addToCart.classList.remove("btn--loading"),
                                                document.body.classList.contains("template-cart") && (window.scrollTo(0, 0), location.reload());
                                        }.bind(this)
                                    );
                            }
                        },
                        success: function (e) {
                            var t = this.form.querySelector(".errors");
                            t && t.remove(),
                                document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: e, addToCartBtn: this.addToCart } })),
                                this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, { detail: { product: e, addToCartBtn: this.addToCart } }));
                        },
                        error: function (e) {
                            if (e.description) {
                                var t = this.form.querySelector(".errors");
                                t && t.remove();
                                var i = document.createElement("div");
                                i.classList.add("errors", "text-center"),
                                    (i.textContent = e.description),
                                    this.form.append(i),
                                    document.dispatchEvent(new CustomEvent("ajaxProduct:error", { detail: { errorMessage: e.description } })),
                                    this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, { detail: { errorMessage: e.description } }));
                            } else console.warn(e);
                        },
                    })),
                    t
                );
            })()),
            (theme.ProductMedia = (function () {
                var e = {},
                    t = {},
                    i = {};
                function s(e) {
                    if (!e) {
                        for (var i in t)
                            if (t.hasOwnProperty(i)) {
                                var s = t[i];
                                !s.modelViewerUi && Shopify && (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)), n(s);
                            }
                    }
                }
                function n(e) {
                    var t = i[e.sectionId];
                    e.container.addEventListener("mediaVisible", function () {
                        t.element.setAttribute("data-shopify-model3d-id", e.modelId), theme.config.isTouch || e.modelViewerUi.play();
                    }),
                        e.container.addEventListener("mediaHidden", function () {
                            t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                        }),
                        e.container.addEventListener("xrLaunch", function () {
                            e.modelViewerUi.pause();
                        });
                }
                return {
                    init: function (n, o) {
                        (e[o] = { loaded: !1 }),
                            n.forEach(function (e, s) {
                                var n = e.dataset.mediaId,
                                    a = e.querySelector("model-viewer"),
                                    r = a.dataset.modelId;
                                if (0 === s) {
                                    var c = e.closest("[data-product-single-media-group]").querySelector("[data-shopify-xr]");
                                    i[o] = { element: c, defaultId: r };
                                }
                                t[n] = { modelId: r, sectionId: o, container: e, element: a };
                            }),
                            window.Shopify.loadFeatures([
                                {
                                    name: "shopify-xr",
                                    version: "1.0",
                                    onLoad: function t(i) {
                                        if (!i) {
                                            if (window.ShopifyXR) {
                                                for (var s in e)
                                                    if (e.hasOwnProperty(s)) {
                                                        var n = e[s];
                                                        if (n.loaded) continue;
                                                        var o = document.querySelector("#ModelJson-" + s);
                                                        window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (n.loaded = !0);
                                                    }
                                                window.ShopifyXR.setupXRElements();
                                            } else
                                                document.addEventListener("shopify_xr_initialized", function () {
                                                    t();
                                                });
                                        }
                                    },
                                },
                                { name: "model-viewer-ui", version: "1.0", onLoad: s },
                            ]),
                            theme.LibraryLoader.load("modelViewerUiStyles");
                    },
                    removeSectionModels: function (i) {
                        for (var s in t) t.hasOwnProperty(s) && t[s].sectionId === i && delete t[s];
                        delete e[i];
                    },
                };
            })()),
            (theme.QtySelector = (function () {
                function e(e, t) {
                    (this.wrapper = e),
                        (this.plus = e.querySelector(".js-qty__adjust--plus")),
                        (this.minus = e.querySelector(".js-qty__adjust--minus")),
                        (this.input = e.querySelector(".js-qty__num")),
                        (this.minValue = this.input.getAttribute("min") || 1);
                    var i = { namespace: null, isCart: !1, key: this.input.dataset.id };
                    (this.options = Object.assign({}, i, t)), this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            this.plus.addEventListener(
                                "click",
                                function () {
                                    var e = this._getQty();
                                    this._change(e + 1);
                                }.bind(this)
                            ),
                                this.minus.addEventListener(
                                    "click",
                                    function () {
                                        var e = this._getQty();
                                        this._change(e - 1);
                                    }.bind(this)
                                ),
                                this.input.addEventListener(
                                    "change",
                                    function (e) {
                                        this._change(this._getQty());
                                    }.bind(this)
                                );
                        },
                        _getQty: function () {
                            var e = this.input.value;
                            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
                        },
                        _change: function (e) {
                            e <= this.minValue && (e = this.minValue),
                                (this.input.value = e),
                                this.options.isCart && document.dispatchEvent(new CustomEvent("cart:quantity" + this.options.namespace, { detail: [this.options.key, e, this.wrapper] }));
                        },
                    })),
                    e
                );
            })()),
(theme.Slideshow = (function () {
    var e = "animate-out",
        t = "is-paused",
        i = "is-active",
        s = ".is-selected",
        n = {
            adaptiveHeight: !1,
            autoPlay: !1,
            avoidReflow: !1,
            childNav: null,
            childNavScroller: null,
            childVertical: !1,
            fade: !1,
            initialIndex: 0,
            pageDots: !1,
            pauseAutoPlayOnHover: !1,
            prevNextButtons: !1,
            rightToLeft: theme.config.rtl,
            setGallerySize: !0,
            wrapAround: !0
        };

    function o(e, t) {
        this.el = e;
        this.args = Object.assign({}, n, t);

        this.args.on = {
            ready: this.init.bind(this),
            change: this.slideChange.bind(this),
            settle: this.afterChange.bind(this)
        };

        /*
         * Child navigation
         */
        if (this.args.childNav) {
            this.childNavEls = this.args.childNav.querySelectorAll(
                ".product__thumb-item:not(.hide)"
            );

            this.childNavLinks = this.args.childNav.querySelectorAll(
                ".product__thumb-item:not(.hide) a"
            );

            this.arrows = this.args.childNav.querySelectorAll(
                ".product__thumb-arrow"
            );

            if (this.childNavLinks.length) {
                this.initChildNav();
            }
        }

        /*
         * Avoid slideshow reflow
         */
        if (this.args.avoidReflow && e.id) {
            var t = e.firstChild;

            while (t && 3 === t.nodeType) {
                t = t.nextSibling;
            }

            if (t) {
                var i = document.createElement("style");

                i.innerHTML =
                    "#" +
                    e.id +
                    " .flickity-viewport{height:" +
                    t.offsetHeight +
                    "px}";

                document.head.appendChild(i);
            }
        }

        /*
         * Initialize Flickity
         */
        this.slideshow = new Flickity(e, this.args);

        /*
         * Autoplay pause button
         */
        if (this.args.autoPlay) {
            var s = e.closest(".slideshow-wrapper");

            if (s) {
                this.pauseBtn = s.querySelector(".slideshow__pause");

                if (this.pauseBtn) {
                    this.pauseBtn.addEventListener(
                        "click",
                        this._togglePause.bind(this)
                    );
                }
            }
        }

        /*
         * Resize listener
         */
        window.on(
            "resize",
            theme.utils.debounce(
                300,
                function () {
                    this.resize();
                }.bind(this)
            )
        );
    }

    return (
        (o.prototype = Object.assign({}, o.prototype, {

            /*
             * Initial slideshow setup
             */
            init: function (e) {
                this.currentSlide = this.el.querySelector(s);

                if (
                    this.args.callbacks &&
                    this.args.callbacks.onInit &&
                    typeof this.args.callbacks.onInit === "function"
                ) {
                    this.args.callbacks.onInit(this.currentSlide);
                }

                /*
                 * Do not run AOS.refresh() during initial LCP rendering.
                 * Refresh AOS after the browser has rendered the page.
                 */
                if (window.AOS) {
                    requestAnimationFrame(function () {
                        setTimeout(function () {
                            AOS.refresh();
                        }, 100);
                    });
                }
            },

            /*
             * Slide change
             */
            slideChange: function (t) {
                if (
                    this.args.fade &&
                    this.currentSlide
                ) {
                    this.currentSlide.classList.add(e);

                    this.currentSlide.addEventListener(
                        "transitionend",
                        function () {
                            this.currentSlide.classList.remove(e);
                        }.bind(this),
                        { once: true }
                    );
                }

                if (this.args.childNav) {
                    this.childNavGoTo(t);
                }

                if (
                    this.args.callbacks &&
                    this.args.callbacks.onChange &&
                    typeof this.args.callbacks.onChange === "function"
                ) {
                    this.args.callbacks.onChange(t);
                }

                if (
                    this.arrows &&
                    this.arrows.length &&
                    this.childNavLinks &&
                    this.childNavLinks.length
                ) {
                    this.arrows[0].classList.toggle(
                        "hide",
                        0 === t
                    );

                    this.arrows[1].classList.toggle(
                        "hide",
                        t === this.childNavLinks.length - 1
                    );
                }
            },

            /*
             * After slide transition
             */
            afterChange: function (t) {
                if (this.args.fade) {
                    this.el
                        .querySelectorAll(".slideshow__slide")
                        .forEach(function (t) {
                            t.classList.remove(e);
                        });
                }

                this.currentSlide = this.el.querySelector(s);

                if (this.args.childNav) {
                    this.childNavGoTo(
                        this.slideshow.selectedIndex
                    );
                }
            },

            /*
             * Destroy slideshow
             */
            destroy: function () {
                if (
                    this.args.childNav &&
                    this.childNavLinks &&
                    this.childNavLinks.length
                ) {
                    this.childNavLinks.forEach(function (e) {
                        e.classList.remove(i);
                    });
                }

                if (this.slideshow) {
                    this.slideshow.destroy();
                }
            },

            /*
             * Pause / play
             */
            _togglePause: function () {
                if (!this.pauseBtn || !this.slideshow) {
                    return;
                }

                if (this.pauseBtn.classList.contains(t)) {
                    this.pauseBtn.classList.remove(t);
                    this.slideshow.playPlayer();
                } else {
                    this.pauseBtn.classList.add(t);
                    this.slideshow.pausePlayer();
                }
            },

            /*
             * Resize
             */
            resize: function () {
                if (this.slideshow) {
                    this.slideshow.resize();
                }
            },

            /*
             * Play
             */
            play: function () {
                if (this.slideshow) {
                    this.slideshow.playPlayer();
                }
            },

            /*
             * Pause
             */
            pause: function () {
                if (this.slideshow) {
                    this.slideshow.pausePlayer();
                }
            },

            /*
             * Go to slide
             */
            goToSlide: function (e) {
                if (this.slideshow) {
                    this.slideshow.select(e);
                }
            },

            /*
             * Enable / disable dragging
             */
            setDraggable: function (e) {
                if (!this.slideshow) {
                    return;
                }

                this.slideshow.options.draggable = e;
                this.slideshow.updateDraggable();
            },

            /*
             * Initialize child navigation
             */
            initChildNav: function () {
                if (
                    !this.childNavLinks ||
                    !this.childNavLinks.length
                ) {
                    return;
                }

                var e = this.args.initialIndex || 0;

                if (this.childNavLinks[e]) {
                    this.childNavLinks[e].classList.add(i);
                }

                this.childNavLinks.forEach(
                    function (t, i) {
                        t.setAttribute("data-index", i);

                        t.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault();

                                this.goToSlide(
                                    this.getChildIndex(
                                        e.currentTarget
                                    )
                                );
                            }.bind(this)
                        );

                        t.addEventListener(
                            "focus",
                            function (e) {
                                this.goToSlide(
                                    this.getChildIndex(
                                        e.currentTarget
                                    )
                                );
                            }.bind(this)
                        );

                        t.addEventListener(
                            "keydown",
                            function (e) {
                                if (13 === e.keyCode) {
                                    this.goToSlide(
                                        this.getChildIndex(
                                            e.currentTarget
                                        )
                                    );
                                }
                            }.bind(this)
                        );
                    }.bind(this)
                );

                if (this.arrows && this.arrows.length) {
                    this.arrows.forEach(
                        function (e) {
                            e.addEventListener(
                                "click",
                                this.arrowClick.bind(this)
                            );
                        }.bind(this)
                    );
                }
            },

            /*
             * Get child slide index
             */
            getChildIndex: function (e) {
                return parseInt(e.dataset.index, 10);
            },

            /*
             * Update child navigation
             */
            childNavGoTo: function (e) {
                if (
                    !this.childNavLinks ||
                    !this.childNavLinks.length
                ) {
                    return;
                }

                this.childNavLinks.forEach(function (e) {
                    e.classList.remove(i);
                });

                var t = this.childNavLinks[e];

                if (!t) {
                    return;
                }

                t.classList.add(i);

                if (this.args.childNavScroller) {
                    if (this.args.childVertical) {
                        var s = t.offsetTop;

                        this.args.childNavScroller.scrollTop =
                            s - 100;
                    } else {
                        var n = t.offsetLeft;

                        this.args.childNavScroller.scrollLeft =
                            n - 100;
                    }
                }
            },

            /*
             * Previous / next arrow
             */
            arrowClick: function (e) {
                if (!this.slideshow) {
                    return;
                }

                if (
                    e.currentTarget.classList.contains(
                        "product__thumb-arrow--prev"
                    )
                ) {
                    this.slideshow.previous();
                } else {
                    this.slideshow.next();
                }
            }
        })),
        o
    );
})()),
            (theme.VariantAvailability = (function () {
                var e = "disabled";
                function t(e) {
                    (this.type = e.type), (this.variantsObject = e.variantsObject), (this.currentVariantObject = e.currentVariantObject), (this.container = e.container), (this.namespace = e.namespace), this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)), this.setAvailability(null, this.currentVariantObject);
                        },
                        setAvailability: function (e, t) {
                            e && (t = e.detail.variant);
                            var i = { option1: [], option2: [], option3: [] },
                                s = this.variantsObject.filter(function (e) {
                                    return (
                                        !(!t || t.id === e.id) &&
                                        ((t.option2 === e.option2 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option3 === e.option3) || (t.option1 === e.option1 && t.option2 === e.option2) || void 0)
                                    );
                                }),
                                n = Object.assign({}, { variant: t }, s);
                            for (var o in (this.container.querySelectorAll(".variant-input-wrap").forEach((e) => {
                                this.disableVariantGroup(e);
                            }),
                            n))
                                if (n.hasOwnProperty(o)) {
                                    var a = n[o];
                                    if (!a) return;
                                    var r = a.option1,
                                        c = a.option2,
                                        l = a.option3,
                                        d = !1 === a.available;
                                    r && i.option1.push({ value: r, soldOut: d }), c && i.option2.push({ value: c, soldOut: d }), l && i.option3.push({ value: l, soldOut: d });
                                }
                            for (var [h, u] of Object.entries(i)) this.manageOptionState(h, u);
                        },
                        manageOptionState: function (e, t) {
                            var i = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
                            t.forEach((e) => {
                                this.enableVariantOption(i, e);
                            });
                        },
                        enableVariantOptionByValue: function (e, t) {
                            for (var i = this.container.querySelector('.variant-input-wrap[data-index="' + t + '"]'), s = 0; s < e.length; s++) this.enableVariantOption(i, e[s]);
                        },
                        enableVariantOption: function (t, i) {
                            var s = i.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                            if ("dropdown" === this.type) t.querySelector('option[value="' + s + '"]').disabled = !1;
                            else {
                                var n = t.querySelector('.variant-input[data-value="' + s + '"]'),
                                    o = n.querySelector("input"),
                                    a = n.querySelector("label");
                                o.classList.remove(e), a.classList.remove(e), i.soldOut && (o.classList.add(e), a.classList.add(e));
                            }
                        },
                        disableVariantGroup: function (t) {
                            "dropdown" === this.type
                                ? t.querySelectorAll("option").forEach((e) => {
                                      e.disabled = !0;
                                  })
                                : (t.querySelectorAll("input").forEach((t) => {
                                      t.classList.add(e);
                                  }),
                                  t.querySelectorAll("label").forEach((t) => {
                                      t.classList.add(e);
                                  }));
                        },
                    })),
                    t
                );
            })()),
            (theme.videoModal = function () {
                var e,
                    t = "VideoHolder",
                    i = document.querySelectorAll('a[href*="youtube.com/watch"], a[href*="youtu.be/"]'),
                    s = document.querySelectorAll(".product-video-trigger--mp4");
                if (i.length || s.length) {
                    var n = document.getElementById(t);
                    i.length && theme.LibraryLoader.load("youtubeSdk");
                    var o = new theme.Modals("VideoModal", "video-modal", { closeOffContentClick: !0, bodyOpenClass: ["modal-open", "video-modal-open"], solid: !0 });
                    i.forEach((e) => {
                        e.addEventListener("click", a);
                    }),
                        s.forEach((e) => {
                            e.addEventListener("click", r);
                        }),
                        document.addEventListener("modalClose.VideoModal", function () {
                            e && "function" == typeof e.destroy ? e.destroy() : l();
                        });
                }
                function a(i) {
                    if (theme.config.youTubeReady) {
                        i.preventDefault(), l(), o.open(i);
                        var s,
                            n,
                            a,
                            r = ((s = i.currentTarget.getAttribute("href")), (n = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/), !(!(a = s.match(n)) || 11 != a[7].length) && a[7]);
                        e = new theme.YouTube(t, { videoId: r, style: "sound", events: { onReady: c } });
                    }
                }
                function r(e) {
                    l();
                    var t = e.currentTarget.parentNode.querySelector(".product-video-mp4-sound").cloneNode(!0);
                    t.classList.remove("hide"), n.append(t), o.open(e), n.querySelector("video").play();
                }
                function c(e) {
                    e.target.unMute(), e.target.playVideo();
                }
                function l() {
                    n.innerHTML = "";
                }
            }),
            (theme.ProductScreen = (function () {
                var e = document.title,
                    t = "productscreen",
                    i = 0,
                    s =
                        (document.getElementById("MainContent"),
                        {
                            close: ".js-screen-close",
                            openClass: "screen-layer--is-active",
                            closeSlideAnimate: ["screen-layer--is-sliding"],
                            bodyOpenClass: "screen-layer-open",
                            bodyClosingClass: ["screen-layer-closing"],
                            bodyCloseAnimate: ["screen-layer-closing", "screen-layer-animating"],
                            loaderStart: 200,
                            pullToCloseThreshold: -100,
                        });
                function n(e, t) {
                    (this.id = e),
                        (this.screen = document.getElementById(e)),
                        this.screen &&
                            ((this.nodes = {
                                loader: document.getElementById("OverscrollLoader").querySelector(".icon-loader__path"),
                                screenContent: this.screen.querySelector(".screen-layer__inner"),
                                photoswipe: document.querySelector(".pswp"),
                            }),
                            (this.title = this.screen.dataset.productTitle),
                            (this.openBtnClass = ".js-screen-open-" + t),
                            (this.initalized = !1),
                            (this.isOpen = !1),
                            (this.focusOnOpen = s.focusOnOpen ? this.screen.querySelector(s.focusOnOpen) : this.screen),
                            this.init());
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function () {
                            document.querySelectorAll(this.openBtnClass).forEach((e) => {
                                e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                            }),
                                this.screen.querySelectorAll(s.close).forEach((e) => {
                                    e.on(
                                        "click." + t,
                                        function (e) {
                                            this.close(!1, { noAnimate: !0, back: !0 });
                                        }.bind(this)
                                    );
                                }),
                                "sticky" === theme.settings.cartType &&
                                    (document.addEventListener(
                                        "ajaxProduct:added:" + this.id,
                                        function () {
                                            theme.headerNav.toggleThumbMenu(!1, !0), this.close(!1, { back: !0 });
                                        }.bind(this)
                                    ),
                                    document.addEventListener(
                                        "ajaxProduct:error:" + this.id,
                                        function () {
                                            this.initalized && this.open();
                                        }.bind(this)
                                    ));
                        },
                        open: function (e, n) {
                            this.screen = document.getElementById(this.id);
                            var o = !1,
                                a = { updateCurrentPath: !n || n.updateCurrentPath };
                            if (!this.isOpen) {
                                e ? e.preventDefault() : (o = !0),
                                    e && e.stopPropagation && (e.stopPropagation(), (this.activeSource = e.currentTarget)),
                                    this.isOpen && !o && this.close(),
                                    (i = window.scrollY),
                                    theme.utils.prepareTransition(
                                        this.screen,
                                        function () {
                                            this.screen.classList.add(s.openClass);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.add(s.bodyOpenClass),
                                    document.body.classList.add(s.bodyOpenClass),
                                    this.nodes.screenContent.scrollTo(0, 0),
                                    window.scrollTo(0, 0),
                                    theme.a11y.trapFocus({ container: this.screen, elementToFocus: this.focusOnOpen, namespace: t }),
                                    this.activeSource && this.activeSource.hasAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "true");
                                var r = this.activeSource.dataset.url;
                                document.dispatchEvent(new CustomEvent("productModalOpen." + this.id)),
                                    document.dispatchEvent(new CustomEvent("newPopstate", { detail: { screen: this, url: r, updateCurrentPath: a.updateCurrentPath } })),
                                    (this.initalized = !0),
                                    (this.isOpen = !0),
                                    (document.title = this.title),
                                    window.ga && ga("send", "pageview", { page: r }),
                                    this.bindEvents();
                            }
                        },
                        close: function (n, o) {
                            var a = o || (n ? n.data : null),
                                r = !!a && a.back,
                                c = !(!a || !a.noAnimate);
                            document.body.removeAttribute("style"), (this.nodes.loader.style.strokeDashoffset = s.loaderStart), r && document.dispatchEvent(new CustomEvent("newPopstate", { detail: { screen: this, back: !0 } }));
                            var l = c ? [] : s.closeSlideAnimate,
                                d = c ? s.bodyClosingClass : s.bodyCloseAnimate;
                            this.isOpen &&
                                (document.activeElement.blur(),
                                theme.utils.prepareTransition(
                                    this.screen,
                                    function () {
                                        this.screen.classList.remove(s.openClass), this.screen.classList.add(...l), this.screen.classList.remove("is-transitioning");
                                    }.bind(this)
                                ),
                                document.documentElement.classList.remove(s.bodyOpenClass),
                                document.body.classList.remove(s.bodyOpenClass),
                                document.documentElement.classList.add(...d),
                                document.body.classList.add(...d),
                                window.setTimeout(
                                    function () {
                                        this.screen.classList.remove(...l), document.documentElement.classList.remove(...d), document.body.classList.remove(...d), window.scrollTo(0, i);
                                    }.bind(this),
                                    500
                                ),
                                theme.a11y.removeTrapFocus({ container: this.screen, namespace: t }),
                                this.activeSource && this.activeSource.hasAttribute("aria-expanded") && (this.activeSource.setAttribute("aria-expanded", "false"), this.activeSource.focus()),
                                document.body.dispatchEvent(new CustomEvent("productModalClose")),
                                document.body.dispatchEvent(new CustomEvent("productModalClose." + this.id)),
                                window.scrollTo(0, i),
                                (this.isOpen = !1),
                                (document.title = e),
                                window.ga && ga("send", "pageview"),
                                this.unbindEvents());
                        },
                        bindEvents: function () {
                            window.on(
                                "keyup." + t,
                                function (e) {
                                    27 === e.keyCode && !this.nodes.photoswipe.classList.contains("pswp--open") && (document.body.classList.contains("js-drawer-open") || this.close(!1, { back: !0 }));
                                }.bind(this)
                            );
                            var e = 0,
                                i = 0;
                            window.on(
                                "touchmove." + t,
                                theme.utils.throttle(
                                    15,
                                    function () {
                                        var t = window.scrollY;
                                        t >= 0 ||
                                            ((e = -t / 100), (document.body.style.background = "rgba(0,0,0," + e + ")"), (i = s.loaderStart + 2 * t), t <= s.pullToCloseThreshold && (i = 0), (this.nodes.loader.style.strokeDashoffset = i));
                                    }.bind(this)
                                )
                            ),
                                window.on(
                                    "touchend." + t,
                                    function () {
                                        window.scrollY < s.pullToCloseThreshold && this.close(!1, { back: !0 });
                                    }.bind(this)
                                );
                        },
                        unbindEvents: function () {
                            window.off("keyup." + t), window.off("touchmove." + t), window.off("touchend." + t);
                        },
                    })),
                    n
                );
            })()),
            (theme.QuickShopScreens = (function () {
                var e = window.location.pathname,
                    t = e,
                    i = null;
                "scrollRestoration" in history && (history.scrollRestoration = "manual");
                var s = { screensWrap: "#ProductScreens", screens: "[data-product-id]", trigger: ".quick-product__btn" },
                    n = [];
                function o(e) {
                    e.close(), (i = null), window.dispatchEvent(new Event("resize"));
                }
                function a(e) {
                    var t = [];
                    return (
                        (e ? e.querySelectorAll(s.trigger) : document.querySelectorAll(s.trigger)).forEach((e) => {
                            var i = e.dataset.productId;
                            if (t.indexOf(i) > -1) {
                                var s = document.querySelector('.screen-layer--product[data-product-id="' + i + '"]');
                                s && s.parentNode.removeChild(s);
                            } else t.push(i);
                        }),
                        t
                    );
                }
                function r(e) {
                    for (var t, i, o = document.createDocumentFragment(), a = 0; a < e.length; a++) -1 === n.indexOf(e[a]) && ((t = "ProductScreen-" + e[a]), (i = document.getElementById(t)) && (o.appendChild(i), n.push(e[a])));
                    for (document.querySelector(s.screensWrap).appendChild(o), a = 0; a < n.length; a++) (t = "ProductScreen-" + n[a]), new theme.ProductScreen(t, "product-" + n[a]);
                }
                return {
                    init: function (s) {
                        theme.settings.quickView &&
                            (r(a()),
                            (function () {
                                Shopify.designMode ||
                                    (document.addEventListener("newPopstate", function (s) {
                                        if (s.detail) {
                                            var n = s.detail;
                                            (i = n.screen), n.back && (location.pathname, (t = e), history.pushState({}, "", e)), n.url && n.updateCurrentPath && (location.pathname, (t = n.url), history.pushState({}, "", n.url));
                                        }
                                    }),
                                    window.addEventListener(
                                        "popstate",
                                        function (s) {
                                            var n = !1;
                                            if (location.pathname !== t) {
                                                if (((t = location.pathname), location.pathname !== e)) {
                                                    if (-1 === location.pathname.indexOf("/products/")) {
                                                        if (s.originalEvent && s.originalEvent.state) {
                                                            if (i && i.isOpen) return o(i), void history.replaceState({}, "", e);
                                                            n = !0;
                                                        } else if (i) {
                                                            if (i.isOpen) return void o(i);
                                                        } else n = !0;
                                                        n && (window.location.href = location.href);
                                                    } else i ? i.open() : document.querySelector('.quick-product__btn[href="' + location.pathname + '"]').dispatchEvent(new Event("click"), { updateCurrentPath: !1 });
                                                } else i && i.isOpen && o(i);
                                            }
                                        }.bind(this)
                                    ));
                            })());
                    },
                    unload: function (e) {
                        if (theme.settings.quickView) {
                            for (
                                var t,
                                    i = [],
                                    n = a(e),
                                    o = document.querySelectorAll(s.trigger),
                                    r =
                                        ((t = []),
                                        o.forEach((e) => {
                                            var i = e.dataset.productId;
                                            t.push(i);
                                        }),
                                        t),
                                    c = 0;
                                c < n.length;
                                c++
                            ) {
                                var l = n[c];
                                -1 === r.indexOf(l) && i.push(l);
                            }
                            for (c = 0; c < i.length; c++) sections._removeInstance(i[c]);
                        }
                    },
                    reInit: function (e) {
                        if (theme.settings.quickView) {
                            var t = a(e);
                            r(t),
                                (function (e, t) {
                                    for (var i = 0; i < e.length; i++) {
                                        var s = t.querySelector('.screen-layer--product[data-product-id="' + e[i] + '"]');
                                        s && s.parentNode.removeChild(s);
                                    }
                                })(t, e);
                            var i = document.getElementById("ProductScreens");
                            theme.sections.register("product-template", theme.Product, i);
                        }
                    },
                };
            })()),
            (theme.HoverProductGrid = (function () {
                var e = ".product-slider";
                function t(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".product-image-slider-" + this.sectionId),
                        (this.activeIds = []),
                        (this.allSliders = {}),
                        theme.settings.hoverProductGrid &&
                            ((this.products = e.querySelectorAll(".grid-product")),
                            (this.slidersMobile = e.dataset.productSlidersMobile),
                            0 !== this.products.length &&
                                theme.promiseStylesheet().then(
                                    function () {
                                        this.init();
                                    }.bind(this)
                                ));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.destroyAllSliders(), this.setupEventType(), this.listnerSetup();
                        },
                        setupEventType: function () {
                            this.products.forEach((e) => {
                                e.off("mouseenter" + this.namespace), e.off("mouseout" + this.namespace);
                            }),
                                window.off("scroll" + this.namespace),
                                theme.config.bpSmall ? this.slidersMobile && this.inViewSliderInit() : this.mouseSliderInit();
                        },
                        listnerSetup: function () {
                            document.addEventListener(
                                "matchSmall",
                                function () {
                                    this.destroyAllSliders(), this.setupEventType();
                                }.bind(this)
                            ),
                                document.addEventListener(
                                    "unmatchSmall",
                                    function () {
                                        this.destroyAllSliders(), this.setupEventType();
                                    }.bind(this)
                                );
                        },
                        inViewSliderInit: function () {
                            this.products.forEach((t) => {
                                new IntersectionObserver(
                                    (i, s) => {
                                        i.forEach((i) => {
                                            var s = t.querySelector(e);
                                            theme.config.bpSmall && (i.isIntersecting ? this.initSlider(s) : this.destroySlider(s));
                                        });
                                    },
                                    { threshold: 1 }
                                ).observe(t);
                            });
                        },
                        mouseSliderInit: function () {
                            this.products.forEach((t) => {
                                var i = t.querySelector(e);
                                t.on(
                                    "mouseenter" + this.namespace,
                                    function () {
                                        this.initSlider(i);
                                    }.bind(this)
                                ),
                                    t.on(
                                        "mouseleave" + this.namespace,
                                        function (e) {
                                            this.destroySlider(i);
                                        }.bind(this)
                                    );
                            });
                        },
                        initSlider: function (e) {
                            !e.dataset ||
                                e.dataset.imageCount < 2 ||
                                (-1 === this.activeIds.indexOf(e.dataset.id) &&
                                    (e.classList.add("product-slider--init"), (this.allSliders[e.dataset.id] = new theme.Slideshow(e, { autoPlay: 1050, fade: !0, avoidReflow: !0 })), this.activeIds.push(e.dataset.id)));
                        },
                        destroySlider: function (e) {
                            if (e.dataset && !(e.dataset.imageCount < 2)) {
                                var t = this.activeIds.indexOf(e.dataset.id);
                                if (-1 !== t) {
                                    this.activeIds.splice(t, 1);
                                    var i = this.allSliders[e.dataset.id];
                                    i && "function" == typeof i.destroy && i.destroy();
                                }
                            }
                        },
                        destroyAllSliders: function () {
                            this.products.forEach((t) => {
                                var i = t.querySelector(e);
                                this.destroySlider(i);
                            });
                        },
                    })),
                    t
                );
            })()),
            (theme.slideNav = (function () {
                var e,
                    t,
                    i,
                    s,
                    n,
                    o,
                    a = { container: "#PageContainer", navWrapper: ".slide-nav__overflow", nav: "#SlideNav", toggleBtn: ".js-toggle-slide-nav", subNavToggleBtn: ".js-toggle-submenu", thumbNavToggle: ".site-nav__thumb-button" },
                    r = { subNavLink: "slide-nav__sublist-link", return: "slide-nav__return-btn", isActive: "is-active", isOpen: "js-menu--is-open", subNavShowing: "sub-nav--is-open", thirdNavShowing: "third-nav--is-open" },
                    c = ".slideNav",
                    l = !0,
                    d = 1,
                    h = null;
                function u(e) {
                    (h = e.currentTarget).classList.contains(r.isActive)
                        ? p()
                        : (function (e) {
                              if (
                                  (scrollLock.disablePageScroll(),
                                  n.forEach((e) => {
                                      e.classList.add(r.isActive);
                                  }),
                                  theme.utils.prepareTransition(s, function () {
                                      s.classList.add(r.isOpen);
                                  }),
                                  l)
                              ) {
                                  var t = document.querySelector(a.navWrapper).clientHeight;
                                  i.style.transform = "translate3d(0, " + t + "px, 0)";
                              }
                              s.setAttribute("tabindex", "-1"),
                                  s.focus(),
                                  window.on("keyup" + c, function (e) {
                                      27 === e.keyCode && p();
                                  });
                          })();
                }
                function p() {
                    n.forEach((e) => {
                        e.classList.remove(r.isActive);
                    }),
                        theme.utils.prepareTransition(s, function () {
                            s.classList.remove(r.isOpen);
                        }),
                        l && i.removeAttribute("style"),
                        h.focus(),
                        (h = null),
                        window.off("keyup" + c),
                        scrollLock.enablePageScroll();
                }
                function f(n) {
                    if (!e) {
                        var o,
                            c,
                            h,
                            u,
                            p = n.currentTarget;
                        if (((e = !0), p.classList.contains(r.return)))
                            document.querySelectorAll(a.subNavToggleBtn + '[data-level="' + (d - 1) + '"]').forEach((e) => {
                                e.classList.remove(r.isActive);
                            }),
                                document.querySelectorAll('.slide-nav__dropdown[data-level="' + d + '"]').forEach((e) => {
                                    theme.utils.prepareTransition(e, function () {
                                        e.classList.remove(r.isActive);
                                    });
                                }),
                                t && t.classList.remove(r.isActive);
                        else {
                            p.classList.add(r.isActive);
                            var f = p.nextElementSibling;
                            theme.utils.prepareTransition(f, function () {
                                f.classList.add(r.isActive);
                            });
                        }
                        (t = p),
                            (d = (c = (o = p.dataset.target) ? document.querySelector('.slide-nav__dropdown[data-parent="' + o + '"]') : document.querySelector(a.nav)).dataset.level ? parseInt(c.dataset.level) : 1),
                            (h = c.clientHeight),
                            (u = d > 2 ? r.thirdNavShowing : r.subNavShowing),
                            (s.style.height = h + "px"),
                            s.classList.remove(r.thirdNavShowing),
                            s.classList.add(u),
                            o || (s.classList.remove(r.thirdNavShowing), s.classList.remove(r.subNavShowing)),
                            (e = !1),
                            l && (i.style.transform = "translate3d(0, " + h + "px, 0)");
                    }
                }
                return {
                    init: function () {
                        document.querySelector(a.thumbNavToggle) && (l = !1),
                            (i = document.querySelector(a.container)),
                            (s = document.querySelector(a.navWrapper)),
                            (n = document.querySelectorAll(a.toggleBtn)),
                            (o = document.querySelectorAll(a.subNavToggleBtn)),
                            n.forEach((e) => {
                                e.on("click" + c, u);
                            }),
                            o.forEach((e) => {
                                e.on("click" + c, f);
                            });
                    },
                    unload: function () {
                        window.off(c);
                    },
                };
            })()),
            (theme.promiseStylesheet = function (e) {
                var t = e || theme.stylesheet;
                return (
                    void 0 === this.stylesheetPromise &&
                        (this.stylesheetPromise = new Promise(function (e) {
                            var i = document.querySelector('link[href="' + t + '"]');
                            i.loaded
                                ? e()
                                : (i.addEventListener("load", function () {
                                      setTimeout(e, 0);
                                  }),
                                  setTimeout(e, 1));
                        })),
                    this.stylesheetPromise
                );
            }),
            (window.onpageshow = function (e) {
                e.persisted &&
                    (document.body.classList.remove("unloading"),
                    document.querySelectorAll(".cart__checkout").forEach((e) => {
                        e.classList.remove("btn--loading");
                    }),
                    document.querySelectorAll("#StickySubmit").forEach((e) => {
                        e.classList.remove("btn--loading");
                    })),
                    (event.persisted || (void 0 !== window.performance && window.performance.navigation && 2 === window.performance.navigation.type)) && theme.resetScrollPosition();
            }),
            (theme.resetScrollPosition = function () {
                if (theme.config.hasSessionStorage) {
                    var e = document.location.pathname;
                    sessionStorage["scrollPosition_" + e] && window.scrollTo(0, sessionStorage.getItem("scrollPosition_" + e));
                }
            }),
            (theme.storeScrollPositionOnUnload = function () {
                if (theme.config.hasSessionStorage) {
                    var e = theme.config.isSafari ? "pagehide" : "beforeunload";
                    window.addEventListener(e, function (e) {
                        var t = window.scrollY;
                        sessionStorage.setItem("scrollPosition_" + document.location.pathname, t.toString());
                    });
                }
            }),
            (theme.pageTransitions = function () {
                "true" === document.body.dataset.transitions &&
                    (theme.config.isSafari &&
                        document.querySelectorAll("a").forEach((e) => {
                            window.setTimeout(function () {
                                document.body.classList.remove("unloading");
                            }, 1200);
                        }),
                    document.querySelectorAll('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]').forEach((e) => {
                        e.classList.add("js-no-transition");
                    }),
                    document.querySelectorAll("a:not(.js-no-transition)").forEach((e) => {
                        e.addEventListener("click", function (t) {
                            if (t.metaKey) return !0;
                            var i = e.getAttribute("href");
                            if (i.indexOf(location.pathname) >= 0 && i.indexOf("#") >= 0) return !0;
                            t.preventDefault(),
                                document.body.classList.add("unloading"),
                                window.setTimeout(function () {
                                    location.href = i;
                                }, 50);
                        });
                    }));
            }),
            (theme.headerNav = (function () {
                var e,
                    t,
                    i = {
                        wrapper: ".header-wrapper",
                        siteHeader: ".site-header",
                        logo: ".site-header__logo img",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                        thumbMenu: ".site-nav__thumb-menu",
                    },
                    s = {
                        hasDropdownClass: "site-nav--has-dropdown",
                        hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
                        dropdownActive: "is-focused",
                        stickyCartActive: "body--sticky-cart-open",
                        overlayEnabledClass: "header-wrapper--overlay",
                        overlayedClass: "is-light",
                        thumbMenuInactive: "site-nav__thumb-menu--inactive",
                        stickyClass: "site-header--sticky",
                        overlayStickyClass: "header-wrapper--sticky",
                        openTransitionClass: "site-header--opening",
                    },
                    n = { namespace: ".siteNav", overlayHeader: !1, stickyActive: !1, forceStickyOnMobile: !1, forceCloseThumbNav: !1 };
                function o() {
                    var e;
                    c(),
                        !document.body.classList.contains(s.stickyCartActive) &&
                            theme.config.bpSmall &&
                            "product" !== theme.template &&
                            setTimeout(function () {
                                (n.forceStickyOnMobile = !0), h(!0);
                            }, 25),
                        "bar" !== n.headerStyle ||
                            ((e = document.createElement("div")).classList.add("site-header-sticky"),
                            theme.utils.wrap(t, e),
                            theme.settings.overlayHeader ||
                                (l(),
                                setTimeout(function () {
                                    l(),
                                        0 === document.querySelector(".site-header-sticky").offsetHeight &&
                                            setTimeout(function () {
                                                window.dispatchEvent(new Event("resize"));
                                            }, 500);
                                }, 200)));
                }
                function a() {
                    c(), r(), "bar" === n.headerStyle && l();
                }
                function r() {
                    theme.config.bpSmall ? (n.headerStyle = "button") : (n.headerStyle = e.dataset.headerStyle), (n.stickyThreshold = "button" === n.headerStyle ? 100 : 250), "button" !== n.headerStyle && h(!1);
                }
                function c() {
                    document.querySelectorAll(i.logo).forEach((e) => {
                        var t = e.clientWidth,
                            i = e.closest(".header-item").clientWidth;
                        t > i ? (e.style.maxWidth = i) : e.removeAttribute("style");
                    });
                }
                function l() {
                    var e = document.querySelector(".site-header-sticky");
                    if (e) {
                        var i = t.offsetHeight;
                        e.style.height = i + "px";
                    }
                }
                function d(e) {
                    if (window.scrollY > n.stickyThreshold) n.forceStickyOnMobile && (n.forceStickyOnMobile = !1), n.stickyActive || ("button" === n.headerStyle ? h(!0) : "bar" === n.headerStyle && u(!0));
                    else {
                        if (n.forceStickyOnMobile || !n.stickyActive) return;
                        "button" === n.headerStyle ? theme.config.bpSmall || h(!1) : "bar" === n.headerStyle && u(!1), theme.settings.overlayHeader || l();
                    }
                }
                function h(e, t) {
                    n.forceCloseThumbNav ||
                        document.querySelector(".slide-nav__overflow--thumb").classList.contains("js-menu--is-open") ||
                        (document.querySelector(i.thumbMenu).classList.toggle(s.thumbMenuInactive, !e), (n.stickyActive = e), (n.forceCloseThumbNav = t));
                }
                function u(i) {
                    "bar" === n.headerStyle &&
                        (i
                            ? (t.classList.add(s.stickyClass),
                              theme.settings.overlayHeader && (e.classList.remove(s.overlayedClass), e.classList.add(s.overlayStickyClass)),
                              setTimeout(function () {
                                  t.classList.add(s.openTransitionClass);
                              }, 100))
                            : (t.classList.remove(s.openTransitionClass), t.classList.remove(s.stickyClass), theme.settings.overlayHeader && (e.classList.add(s.overlayedClass), e.classList.remove(s.overlayStickyClass))),
                        (n.stickyActive = i));
                }
                return {
                    init: function () {
                        (e = document.querySelector(i.wrapper)),
                            (t = document.querySelector(i.siteHeader)),
                            (theme.settings.overlayHeader = "true" === t.dataset.overlay),
                            (n.stickyActive = !1),
                            (function () {
                                var e = !1,
                                    t = !1,
                                    o = !1;
                                function a(i) {
                                    e && d(), t && h(), r(i.currentTarget);
                                }
                                function r(t) {
                                    var i = t.parentNode;
                                    if ((i.classList.contains(s.hasDropdownClass) && (i.classList.add(s.dropdownActive), (e = !0)), !theme.config.isTouch && !o)) {
                                        var a = theme.config.isTouch ? "touchend" : "click";
                                        (o = !0),
                                            document.documentElement.on(
                                                a + n.namespace,
                                                function () {
                                                    l(), document.documentElement.off(a + n.namespace), (o = !1);
                                                }.bind(this)
                                            );
                                    }
                                }
                                function c(e, i) {
                                    var n = e.parentNode;
                                    (n.classList.contains(s.hasSubDropdownClass) || i) && (n.classList.add(s.dropdownActive), (t = !0));
                                }
                                function l() {
                                    d(), h();
                                }
                                function d() {
                                    document.querySelectorAll(i.navItems).forEach((e) => {
                                        e.classList.remove(s.dropdownActive);
                                    });
                                }
                                function h() {
                                    document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                                        e.parentNode.classList.remove(s.dropdownActive);
                                    });
                                }
                                theme.config.isTouch &&
                                    document.querySelectorAll(i.navLinksWithDropdown).forEach((e) => {
                                        e.on("touchend" + n.namespace, function (e) {
                                            e.currentTarget.parentNode.classList.contains(s.dropdownActive) ? window.location.replace(e.currentTarget.getAttribute("href")) : (e.preventDefault(), l(), r(e.currentTarget));
                                        });
                                    }),
                                    document.querySelectorAll(i.navLinks).forEach((e) => {
                                        e.on("focusin" + n.namespace, a), e.on("mouseover" + n.namespace, a), e.on("mouseleave" + n.namespace, l);
                                    }),
                                    document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                                        theme.config.isTouch &&
                                            e.on("touchend" + n.namespace, function (e) {
                                                var t = e.currentTarget.parentNode;
                                                t.classList.contains(s.hasSubDropdownClass)
                                                    ? t.classList.contains(s.dropdownActive)
                                                        ? window.location.replace(e.currentTarget.getAttribute("href"))
                                                        : (e.preventDefault(), h(), c(e.currentTarget))
                                                    : window.location.replace(e.currentTarget.getAttribute("href"));
                                            }),
                                            e.on("focusin" + n.namespace, function (e) {
                                                h(), c(e.currentTarget, !0);
                                            });
                                    });
                            })(),
                            new theme.Modals("SearchModal", "search-modal", { closeOffContentClick: !1, focusIdOnOpen: "SearchModalInput" }),
                            window.on("resize" + n.namespace, theme.utils.debounce(150, a)),
                            window.on("load" + n.namespace, o),
                            r(),
                            window.on("scroll" + n.namespace, theme.utils.throttle(150, d)),
                            window.on("scroll" + n.namespace, theme.utils.debounce(150, d)),
                            Shopify.designMode && window.dispatchEvent(new Event("resize"));
                    },
                    disableOverlayHeader: function () {
                        e.classList.remove(n.overlayEnabledClass), e.classList.remove(n.overlayedClass), (theme.settings.overlayHeader = !1);
                    },
                    toggleThumbMenu: h,
                    unload: function () {
                        window.off(n.namespace);
                    },
                };
            })()),
            (theme.articleImages = function () {
                var e = document.querySelectorAll(".rte--indented-images");
                e.length &&
                    e.forEach((e) => {
                        e.querySelectorAll("img").forEach((t) => {
                            var i = t.getAttribute("style");
                            (i && "float: none;" != i) || (t.width < e.offsetWidth && t.classList.add("rte__no-indent"));
                        });
                    });
            }),
            (theme.customerTemplates = function () {
                var e, t, i, s;
                function n() {
                    document.getElementById("RecoverPasswordForm").classList.toggle("hide"), document.getElementById("CustomerLoginForm").classList.toggle("hide");
                }
                "#recover" === window.location.hash && n(),
                    (e = document.getElementById("RecoverPassword")) &&
                        e.addEventListener("click", function (e) {
                            e.preventDefault(), n();
                        }),
                    (t = document.getElementById("HideRecoverPasswordLink")) &&
                        t.addEventListener("click", function (e) {
                            e.preventDefault(), n();
                        }),
                    document.querySelector(".reset-password-success") && document.getElementById("ResetSuccess").classList.remove("hide"),
                    (i = document.getElementById("AddressNewForm")),
                    (s = document.querySelectorAll(".js-address-form")),
                    i &&
                        s.length &&
                        (setTimeout(function () {
                            document.querySelectorAll(".js-address-country").forEach((e) => {
                                var t = e.dataset.countryId,
                                    i = e.dataset.provinceId,
                                    s = e.dataset.provinceContainerId;
                                new Shopify.CountryProvinceSelector(t, i, { hideElement: s });
                            });
                        }, 1e3),
                        document.querySelectorAll(".address-new-toggle").forEach((e) => {
                            e.addEventListener("click", function () {
                                i.classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-edit-toggle").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                var t = e.currentTarget.dataset.formId;
                                document.getElementById("EditAddress_" + t).classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-delete").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                var t = e.currentTarget.dataset.formId;
                                confirm(e.currentTarget.dataset.confirmMessage || "Are you sure you wish to delete this address?") && Shopify && Shopify.postLink("/account/addresses/" + t, { parameters: { _method: "delete" } });
                            });
                        }));
            }),
            (theme.CartDrawer = (function () {
                function e() {
                    (this.form = document.querySelector("#CartDrawerForm")), (this.drawer = new theme.Drawers("CartDrawer", "cart")), this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            (this.cartForm = new theme.CartForm(this.form)),
                                this.cartForm.buildCart(),
                                document.addEventListener(
                                    "ajaxProduct:added",
                                    function (e) {
                                        this.cartForm.buildCart(), this.open();
                                    }.bind(this)
                                ),
                                document.addEventListener("cart:open", this.open.bind(this)),
                                document.addEventListener("cart:close", this.close.bind(this));
                        },
                        open: function () {
                            this.drawer.open();
                        },
                        close: function () {
                            this.drawer.close();
                        },
                    })),
                    e
                );
            })()),
            (theme.refreshCart = function () {
                "sticky" === theme.settings.cartType &&
                    theme.StickyCart &&
                    theme.cart.getCart().then(function (e) {
                        theme.StickyCart.refresh(e);
                    });
            }),
            (theme.StickyCart = (function () {
                var e = "#StickyCart",
                    t = "#StickyItems",
                    i = "#StickySubtotal",
                    s = "sticky-cart--open",
                    n = "body--sticky-cart-open";
                function o() {
                    (this.status = { loaded: !1, loading: !1, open: document.body.classList.contains(n) }), document.querySelector(e) && this.initEventListeners();
                }
                return (
                    (o.prototype = Object.assign({}, o.prototype, {
                        initEventListeners: function () {
                            var e = document.querySelector("#StickySubmit");
                            e.addEventListener("click", function () {
                                e.classList.add("btn--loading");
                            }),
                                document.addEventListener(
                                    "ajaxProduct:added",
                                    function () {
                                        this.hideCart(),
                                            theme.cart.getCart().then(
                                                function (e) {
                                                    this.buildCart(e, !0);
                                                }.bind(this)
                                            );
                                    }.bind(this)
                                );
                        },
                        hideCart: function () {
                            document.body.classList.remove(n), document.querySelector(e).classList.remove(s);
                        },
                        showCart: function (o, a) {
                            o && (document.querySelector(t).innerText = theme.strings.cartItems.replace("[count]", o)),
                                a && (document.querySelector(i).innerHTML = theme.Currency.formatMoney(a, theme.settings.moneyFormat)),
                                document.body.classList.add(n),
                                document.querySelector(e).classList.add(s),
                                (this.status.open = !0);
                        },
                        buildCart: function (e, t) {
                            this.loading(!0), (this.status.loaded = !0), this.loading(!1), !0 === t && this.showCart(e.item_count, e.total_price);
                        },
                        loading: function (t) {
                            (this.status.loading = t), t ? document.querySelector(e).classList.add("is-loading") : document.querySelector(e).classList.remove("is-loading");
                        },
                        updateError: function (e) {
                            e.responseJSON && e.responseJSON.description && console.warn(e.responseJSON.description);
                        },
                    })),
                    {
                        init: o,
                        refresh: function (o) {
                            document.body.classList.contains("template-cart") ||
                                (o.item_count > 0 ? (document.body.classList.add(n), document.querySelector(e).classList.add(s)) : (document.body.classList.remove(n), document.querySelector(e).classList.remove(s)),
                                (document.querySelector(t).innerText = theme.strings.cartItems.replace("[count]", o.item_count)),
                                (document.querySelector(i).innerHTML = theme.Currency.formatMoney(o.total_price, theme.settings.moneyFormat)));
                        },
                    }
                );
            })()),
            (theme.Product = (function () {
                var e = {},
                    t = "sale-price",
                    i = "disabled",
                    s = "hide",
                    n = "visually-invisible",
                    o = "thumb--current",
                    a = {
                        variantsJson: "[data-variant-json]",
                        currentVariantJson: "[data-current-variant-json]",
                        imageContainer: "[data-product-images]",
                        mainSlider: "[data-product-photos]",
                        thumbSlider: "[data-product-thumbs]",
                        thumbScroller: "[data-product-thumbs-scroller]",
                        photo: "[data-product-photo]",
                        photoThumbs: "[data-product-thumb]",
                        photoThumbItem: "[data-product-thumb-item]",
                        zoomButton: ".product__photo-zoom",
                        priceWrapper: "[data-price-wrapper]",
                        price: "[data-product-price]",
                        comparePrice: "[data-product-price-compare]",
                        priceA11y: "[data-price-a11y]",
                        comparePriceA11y: "[data-compare-a11y]",
                        sku: "[data-sku]",
                        inventory: "[data-product-inventory]",
                        incomingInventory: "[data-product-incoming-inventory]",
                        unitWrapper: "[data-product-unit-wrapper]",
                        addToCart: "[data-add-to-cart]",
                        addToCartText: "[data-add-to-cart-text]",
                        variantType: ".variant-wrapper",
                        originalSelectorId: "[data-product-select]",
                        singleOptionSelector: "[data-variant-input]",
                        variantColorSwatch: "[data-color-swatch]",
                        productImageMain: ".product-image-main",
                        productVideo: "[data-product-video]",
                        videoParent: ".product__video-wrapper",
                        slide: ".product-main-slide",
                        currentSlide: ".is-selected",
                        startingSlide: ".starting-slide",
                        media: "[data-product-media-type-model]",
                        closeMedia: ".product-single__close-media",
                        blocks: "[data-product-blocks]",
                        blocksHolder: "[data-blocks-holder]",
                        formContainer: ".product-single__form",
                        availabilityContainer: "[data-store-availability]",
                    };
                function r(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.productId = e.getAttribute("data-product-id")),
                        (this.inModal = "true" === e.dataset.modal),
                        this.modal,
                        (this.namespace = ".product-" + this.sectionId),
                        (this.namespaceImages = ".product-image-" + this.sectionId),
                        (this.settings = {
                            enableHistoryState: "true" === e.dataset.history,
                            namespace: ".product-" + this.sectionId,
                            inventory: !1,
                            inventoryThreshold: 10,
                            modalInit: !1,
                            hasImages: !0,
                            hasVideos: e.querySelectorAll(a.productVideo).length || !1,
                            videoStyle: e.dataset.videoStyle,
                            has3d: !1,
                            imageSetName: null,
                            imageSetIndex: null,
                            currentImageSet: null,
                            stackedImages: e.dataset.imagesStacked || !1,
                            stackedCurrent: 0,
                            stackedImagePositions: [],
                            imageSize: "620x",
                            currentSlideIndex: 0,
                            videoLooping: e.dataset.videoLooping,
                        }),
                        (this.videos = {}),
                        this.inModal && ((this.settings.enableHistoryState = !1), (this.namespace = ".product-" + this.sectionId + "-modal"), (this.modal = document.getElementById("ProductScreen-" + this.sectionId))),
                        this.init();
                }
                return (
                    (r.prototype = Object.assign({}, r.prototype, {
                        init: function () {
                            (this.mainSlider = this.container.querySelector(a.mainSlider)),
                                (this.thumbSlider = this.container.querySelector(a.thumbSlider)),
                                (this.firstProductImage = this.mainSlider.querySelector("img")),
                                this.firstProductImage || (this.settings.hasImages = !1);
                            var e = this.mainSlider.querySelector("[data-set-name]");
                            (this.settings.imageSetName = !!e && e.dataset.setName),
                                this.inModal &&
                                    (this.container.classList.add("is-modal"),
                                    document.removeEventListener("productModalOpen.ProductScreen-" + this.sectionId, this.openModalProduct.bind(this)),
                                    document.removeEventListener("productModalClose.ProductScreen-" + this.sectionId, this.openModalProduct.bind(this)),
                                    document.addEventListener("productModalOpen.ProductScreen-" + this.sectionId, this.openModalProduct.bind(this)),
                                    document.addEventListener("productModalClose.ProductScreen-" + this.sectionId, this.closeModalProduct.bind(this))),
                                this.inModal || (this.formSetup(), this.preImageSetup(), this.videoSetup(), this.initProductSlider());
                        },
                        formSetup: function () {
                            this.initAjaxProductForm(), this.availabilitySetup(), this.initVariants(), this.settings.imageSetName && this.updateImageSet();
                        },
                        availabilitySetup: function () {
                            var e = this.container.querySelector(a.availabilityContainer);
                            e && (this.storeAvailability = new theme.StoreAvailability(e));
                        },
                        initVariants: function () {
                            var e = this.container.querySelector(a.variantsJson);
                            if (e) {
                                this.variantsObject = JSON.parse(e.innerHTML);
                                var t = {
                                        container: this.container,
                                        enableHistoryState: this.settings.enableHistoryState,
                                        singleOptionSelector: a.singleOptionSelector,
                                        originalSelectorId: a.originalSelectorId,
                                        variants: this.variantsObject,
                                    },
                                    i = this.container.querySelectorAll(a.variantColorSwatch);
                                if (
                                    (i.length &&
                                        i.forEach((e) => {
                                            e.addEventListener(
                                                "change",
                                                function (t) {
                                                    var i = e.dataset.colorName,
                                                        s = e.dataset.colorIndex;
                                                    this.updateColorName(i, s);
                                                }.bind(this)
                                            );
                                        }),
                                    (this.variants = new theme.Variants(t)),
                                    this.storeAvailability)
                                ) {
                                    var s = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
                                    this.storeAvailability.updateContent(s), this.container.on("variantChange" + this.settings.namespace, this.updateAvailability.bind(this));
                                }
                                this.container.on("variantChange" + this.namespace, this.updateCartButton.bind(this)),
                                    this.container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)),
                                    this.container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)),
                                    this.container.on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)),
                                    this.container.querySelectorAll(a.sku).length && this.container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this));
                                var n = this.container.querySelector(a.inventory);
                                if (
                                    (n && ((this.settings.inventory = !0), (this.settings.inventoryThreshold = n.dataset.threshold), this.container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this))),
                                    theme.settings.dynamicVariantsEnable)
                                ) {
                                    var o = this.container.querySelector(a.currentVariantJson);
                                    if (o) {
                                        var r = this.container.querySelector(a.variantType);
                                        r &&
                                            new theme.VariantAvailability({
                                                container: this.container,
                                                namespace: this.settings.namespace,
                                                type: r.dataset.type,
                                                variantsObject: this.variantsObject,
                                                currentVariantObject: JSON.parse(o.innerHTML),
                                                form: this.container.querySelector(a.formContainer),
                                            });
                                    }
                                }
                                if (this.settings.imageSetName) {
                                    var c = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
                                    c ? ((this.settings.imageSetIndex = c.dataset.index), this.container.on("variantChange" + this.settings.namespace, this.updateImageSet.bind(this))) : (this.settings.imageSetName = null);
                                }
                            }
                        },
                        initAjaxProductForm: function () {
                            if ("drawer" === theme.settings.cartType || "sticky" === theme.settings.cartType) {
                                var e = this.container.querySelector(a.formContainer);
                                new theme.AjaxProduct(e, a.addToCart, { scopedEventId: "ProductScreen-" + this.sectionId });
                            }
                        },
                        updateColorName: function (e, t) {
                            this.container.querySelector("#VariantColorLabel-" + this.sectionId + "-" + t).textContent = e;
                        },
                        updateCartButton: function (e) {
                            var t = e.detail.variant,
                                s = this.container.querySelector(a.addToCart),
                                n = this.container.querySelector(a.addToCartText);
                            if (t) {
                                if (t.available) {
                                    s.classList.remove(i), (s.disabled = !1);
                                    var o = n.dataset.defaultText;
                                    n.textContent = o;
                                } else s.classList.add(i), (s.disabled = !0), (n.textContent = theme.strings.soldOut);
                            } else s.classList.add(i), (s.disabled = !0), (n.textContent = theme.strings.unavailable);
                        },
                        updatePrice: function (e) {
                            var i = e.detail.variant;
                            i &&
                                ((this.container.querySelector(a.price).innerHTML = theme.Currency.formatMoney(i.price, theme.settings.moneyFormat)),
                                i.compare_at_price > i.price
                                    ? ((this.container.querySelector(a.comparePrice).innerHTML = theme.Currency.formatMoney(i.compare_at_price, theme.settings.moneyFormat)),
                                      this.container.querySelector(a.priceWrapper).classList.remove(s),
                                      this.container.querySelector(a.price).classList.add(t),
                                      this.container.querySelector(a.comparePriceA11y).setAttribute("aria-hidden", "false"),
                                      this.container.querySelector(a.priceA11y).setAttribute("aria-hidden", "false"))
                                    : (this.container.querySelector(a.priceWrapper).classList.add(s),
                                      this.container.querySelector(a.price).classList.remove(t),
                                      this.container.querySelector(a.comparePriceA11y).setAttribute("aria-hidden", "true"),
                                      this.container.querySelector(a.priceA11y).setAttribute("aria-hidden", "true")));
                        },
                        updateUnitPrice: function (e) {
                            var t = e.detail.variant;
                            if (t && t.unit_price) {
                                var i = theme.Currency.formatMoney(t.unit_price, theme.settings.moneyFormat),
                                    o = theme.Currency.getBaseUnit(t),
                                    r = this.container.querySelector(a.unitWrapper);
                                (r.innerHTML = i + "/" + o), r.classList.remove(s, n);
                            } else this.container.querySelector(a.unitWrapper).classList.add(n);
                        },
                        imageSetArguments: function (e) {
                            if ((e = e || (this.variants ? this.variants.currentVariant : null))) {
                                var t = (this.settings.currentImageSet = this.getImageSetName(e[this.settings.imageSetIndex])),
                                    i = this.settings.imageSetName + "_" + t;
                                return (this.settings.currentSlideIndex = 0), { cellSelector: '[data-group="' + i + '"]', imageSet: i, initialIndex: this.settings.currentSlideIndex };
                            }
                        },
                        updateImageSet: function (e, t) {
                            var i = e ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                            if (i) {
                                var n = this.getImageSetName(i[this.settings.imageSetIndex]),
                                    o = this.settings.imageSetName + "_" + n;
                                if (this.settings.currentImageSet !== n)
                                    return !theme.config.bpSmall && this.settings.stackedImages
                                        ? (this.container.querySelectorAll("[data-group]").forEach((e) => {
                                              e.classList.add(s), e.dataset.group && e.dataset.group === o && e.classList.remove(s);
                                          }),
                                          this.stackedImagePositions(),
                                          AOS.refresh(),
                                          void (this.settings.currentImageSet = n))
                                        : (theme.config.bpSmall &&
                                              this.settings.stackedImages &&
                                              this.container.querySelectorAll("[data-group]").forEach((e) => {
                                                  e.classList.remove(s);
                                              }),
                                          void this.initProductSlider(i));
                            }
                        },
                        updateImageSetThumbs: function (e) {
                            this.settings.stackedImages ||
                                this.thumbSlider.querySelectorAll(".product__thumb-item").forEach((t) => {
                                    t.classList.toggle(s, t.dataset.group !== e);
                                });
                        },
                        getImageSetName: function (e) {
                            return e
                                .toLowerCase()
                                .replace(/[^a-z0-9]+/g, "-")
                                .replace(/-$/, "")
                                .replace(/^-/, "");
                        },
                        updateSku: function (e) {
                            var t = e.detail.variant,
                                i = "",
                                n = !0;
                            t &&
                                (t.sku && ((i = t.sku), (n = !1)),
                                this.container.querySelectorAll(a.sku).forEach((e) => {
                                    e.classList.toggle(s, n), (e.textContent = i);
                                }));
                        },
                        updateInventory: function (e) {
                            var t = e.detail.variant;
                            if (!t || !t.inventory_management || "continue" === t.inventory_policy) return this.toggleInventoryQuantity(t, !1), void this.toggleIncomingInventory(!1);
                            if ("shopify" === t.inventory_management && window.inventories && window.inventories[this.productId]) {
                                var i = window.inventories[this.productId][t.id];
                                if ("continue" === i.policy) return this.toggleInventoryQuantity(t, !1), void this.toggleIncomingInventory(!1);
                                var s = i.quantity,
                                    n = !0,
                                    o = !1;
                                (s <= 0 || s > this.settings.inventoryThreshold) && (n = !1),
                                    this.toggleInventoryQuantity(t, n, s),
                                    !n && "true" === i.incoming && s <= this.settings.inventoryThreshold && (o = !0),
                                    this.toggleIncomingInventory(o, t.available, i.next_incoming_date);
                            }
                        },
                        updateAvailability: function (e) {
                            var t = e.detail.variant;
                            t && this.storeAvailability.updateContent(t.id);
                        },
                        toggleInventoryQuantity: function (e, t, i) {
                            this.settings.inventory;
                            var n = this.container.querySelector(a.inventory),
                                o = n.closest(".product-block");
                            parseInt(i) <= parseInt(this.settings.inventoryThreshold)
                                ? (n.parentNode.classList.add("inventory--low"), (n.textContent = theme.strings.stockLabel.replace("[count]", i)))
                                : (n.parentNode.classList.remove("inventory--low"), (n.textContent = theme.strings.inStockLabel)),
                                e && e.available ? (n.parentNode.classList.remove(s), o && o.classList.remove(s)) : (n.parentNode.classList.add(s), o && o.classList.add(s));
                        },
                        toggleIncomingInventory: function (e, t, i) {
                            var n = this.container.querySelector(a.incomingInventory),
                                o = n.closest(".product-block");
                            if (n) {
                                var r = n.querySelector(".js-incoming-text");
                                if (e) {
                                    var c = t ? theme.strings.willNotShipUntil.replace("[date]", i) : theme.strings.willBeInStockAfter.replace("[date]", i);
                                    i || (c = theme.strings.waitingForStock), n.classList.remove(s), o && o.classList.remove(s), (r.textContent = c);
                                } else n.classList.add(s);
                            }
                        },
                        videoSetup: function () {
                            var e = this.mainSlider.querySelectorAll(a.productVideo);
                            if (!e.length) return !1;
                            e.forEach((e) => {
                                var t = e.dataset.videoType;
                                "youtube" === t ? this.initYoutubeVideo(e) : "mp4" === t && this.initMp4Video(e);
                            });
                        },
                        initYoutubeVideo: function (t) {
                            e[t.id] = new theme.YouTube(t.id, {
                                videoId: t.dataset.youtubeId,
                                videoParent: a.videoParent,
                                autoplay: !1,
                                style: t.dataset.videoStyle,
                                loop: t.dataset.videoLoop,
                                events: { onReady: this.youtubePlayerReady.bind(this), onStateChange: this.youtubePlayerStateChange.bind(this) },
                            });
                        },
                        youtubePlayerReady: function (t) {
                            var i = t.target.getIframe().id;
                            if (e[i]) {
                                var s = e[i],
                                    n = s.videoPlayer;
                                "sound" !== s.options.style && n.mute(), s.parent.classList.remove("loading"), s.parent.classList.add("loaded"), this._isFirstSlide(i) && "sound" !== s.options.style && n.playVideo();
                            }
                        },
                        _isFirstSlide: function (e) {
                            return this.mainSlider.querySelector(a.startingSlide + " #" + e);
                        },
                        youtubePlayerStateChange: function (t) {
                            var i = e[t.target.getIframe().id];
                            switch (t.data) {
                                case -1:
                                    i.attemptedToPlay && i.parent.classList.add("video-interactable");
                                    break;
                                case 0:
                                    i && "true" === i.options.loop && i.videoPlayer.playVideo();
                                    break;
                                case 3:
                                    i.attemptedToPlay = !0;
                            }
                        },
                        initMp4Video: function (t) {
                            (e[t.id] = { id: t.id, type: "mp4" }), this._isFirstSlide(t.id) && this.playMp4Video(t.id);
                        },
                        stopVideos: function () {
                            for (var [t, i] of Object.entries(e)) i.videoPlayer ? "function" == typeof i.videoPlayer.stopVideo && i.videoPlayer.stopVideo() : "mp4" === i.type && this.stopMp4Video(i.id);
                        },
                        _getVideoType: function (e) {
                            return e.getAttribute("data-video-type");
                        },
                        _getVideoDivId: function (e) {
                            return e.id;
                        },
                        playMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e),
                                i = t.play();
                            t.setAttribute("controls", ""),
                                t.focus(),
                                t.addEventListener("focusout", this.returnFocusToThumbnail.bind(this)),
                                void 0 !== i &&
                                    i
                                        .then(function () {})
                                        .catch(function (e) {
                                            t.setAttribute("controls", ""), t.closest(a.videoParent).setAttribute("data-video-style", "unmuted");
                                        });
                        },
                        stopMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e);
                            t.removeEventListener("focusout", this.returnFocusToThumbnail.bind(this)), t && "function" == typeof t.pause && (t.removeAttribute("controls"), t.pause());
                        },
                        returnFocusToThumbnail: function () {
                            var e = this.container.querySelector('.product__thumb-item[data-index="' + this.settings.currentSlideIndex + '"] a');
                            e && e.focus();
                        },
                        preImageSetup: function () {
                            this.setImageSizes(), this.initImageSwitch(), this.initImageZoom(), this.customMediaListners(), this.initModelViewerLibraries(), this.initShopifyXrLaunch(), theme.collapsibles.init(this.container);
                            var e = this.firstProductImage.alt.split("|")[1],
                                t = document.querySelectorAll(".bundle__group");
                            if (e) {
                                var i = e.split(",");
                                i.length > 1 &&
                                    i.forEach((e, i) => {
                                        var s = e.trim().toLowerCase().replace(/\s+/g, " ");
                                        t[i].querySelectorAll(".bundle-variant-box").forEach(function (e) {
                                            e.getAttribute("title").trim().toLowerCase().replace(/\s+/g, " ").includes(s) && e.click();
                                        });
                                    });
                            }
                            window.SPR && (SPR.initDomEls(), SPR.loadBadges());
                        },
                        initProductSlider: function (e) {
                            if (this.mainSlider.querySelectorAll(a.slide).length <= 1) {
                                var t = this.mainSlider.querySelector(a.slide);
                                return console.log("slide", t), void (t && t.classList.add("is-selected"));
                            }
                            if (((this.settings.has3d = this.container.querySelectorAll(a.media).length), "muted" !== this.settings.videoStyle && theme.videoModal(!0), !e)) {
                                var i = this.mainSlider.querySelector(a.startingSlide);
                                this.settings.currentSlideIndex = this._slideIndex(i);
                            }
                            var s = {
                                adaptiveHeight: !0,
                                avoidReflow: !0,
                                initialIndex: this.settings.currentSlideIndex,
                                childNav: this.thumbSlider,
                                childNavScroller: this.container.querySelector(a.thumbScroller),
                                childVertical: "beside" === this.thumbSlider.dataset.position,
                                fade: !this.settings.stackedImages,
                                pageDots: 0,
                                prevNextButtons: !0,
                                wrapAround: !0,
                                callbacks: { onInit: this.onSliderInit.bind(this), onChange: this.onSlideChange.bind(this) },
                            };
                            this.settings.imageSetName && ((s = Object.assign({}, s, this.imageSetArguments(e))), this.updateImageSetThumbs(s.imageSet)),
                                this.initSliders(s),
                                document.addEventListener(
                                    "matchSmall",
                                    function () {
                                        this.initSliders(s, !0);
                                    }.bind(this)
                                ),
                                document.addEventListener(
                                    "unmatchSmall",
                                    function () {
                                        this.initSliders(s, !0);
                                    }.bind(this)
                                );
                        },
                        onSliderInit: function (e) {
                            this.settings.imageSetName && this.prepMediaOnSlide(e),
                                0 === this.mainSlider.offsetHeight &&
                                    setTimeout(function () {
                                        window.dispatchEvent(new Event("resize"));
                                    }, 250);
                        },
                        onSlideChange: function (e) {
                            if (this.flickity) {
                                var t = this.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'),
                                    i = this.settings.imageSetName ? this.mainSlider.querySelectorAll(".flickity-slider .product-main-slide")[e] : this.mainSlider.querySelector('.product-main-slide[data-index="' + e + '"]');
                                t.setAttribute("tabindex", "-1"), i.setAttribute("tabindex", 0);
                                var s = i.querySelector("img").alt.split("|")[1],
                                    n = document.querySelectorAll(".bundle__group");
                                if (s) {
                                    var o = s.split(",");
                                    o.length > 1 &&
                                        o.forEach((e, t) => {
                                            var i = e.trim().toLowerCase().replace(/\s+/g, " ");
                                            n[t].querySelectorAll(".bundle-variant-box").forEach(function (e) {
                                                e.getAttribute("title").trim().toLowerCase().replace(/\s+/g, " ").includes(i) && e.click();
                                            });
                                        });
                                }
                                this.stopMediaOnSlide(t), this.prepMediaOnSlide(i), (this.settings.currentSlideIndex = e);
                            }
                        },
                        stopMediaOnSlide(t) {
                            var i = t.querySelector(a.productVideo);
                            if (i) {
                                var s = this._getVideoType(i),
                                    n = this._getVideoDivId(i);
                                if ("youtube" === s) {
                                    if (e[n].videoPlayer) return void e[n].videoPlayer.stopVideo();
                                } else if ("mp4" === s) return void this.stopMp4Video(n);
                            }
                            var o = t.querySelector(a.media);
                            o && o.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                        },
                        prepMediaOnSlide(t) {
                            var i = t.querySelector(a.productVideo);
                            if (i) {
                                var s = this._getVideoType(i),
                                    n = this._getVideoDivId(i);
                                if ("youtube" === s) {
                                    if (e[n].videoPlayer && "sound" !== e[n].options.style) return void e[n].videoPlayer.playVideo();
                                } else "mp4" === s && this.playMp4Video(n);
                            }
                            var o = t.querySelector(a.media);
                            o &&
                                (o.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                                t.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0),
                                t.querySelector(".product-single__close-media").setAttribute("tabindex", 0)),
                                this.hideZoomOverlay(o);
                        },
                        _slideIndex: function (e) {
                            return e.getAttribute("data-index");
                        },
                        initImageZoom: function () {
                            var e = this.container.querySelector(a.imageContainer);
                            e &&
                                (new theme.Photoswipe(e, this.sectionId),
                                e.addEventListener(
                                    "photoswipe:afterChange",
                                    function (e) {
                                        this.flickity && this.flickity.goToSlide(e.detail.index);
                                    }.bind(this)
                                ));
                        },
                        getThumbIndex: function (e) {
                            return e.dataset.index;
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var e = this.firstProductImage.currentSrc;
                                e && (this.settings.imageSize = theme.Images.imageSize(e));
                            }
                        },
                        updateVariantImage: function (e) {
                            var t = e.detail.variant,
                                i = (theme.Images.getSizedImageUrl(t.featured_media.preview_image.src, this.settings.imageSize), this.container.querySelector('.product-main-slide[data-id="' + t.featured_media.id + '"]')),
                                s = this.getThumbIndex(i);
                            void 0 !== s && (!theme.config.bpSmall && this.settings.stackedImages ? this.stackedScrollTo(s) : this.flickity && this.flickity.goToSlide(s));
                        },
                        initImageSwitch: function () {
                            var e = this.container.querySelectorAll(a.photoThumbs);
                            e.length &&
                                e.forEach((e) => {
                                    e.addEventListener(
                                        "click",
                                        function (t) {
                                            var i = e.querySelector("img").alt.split("|")[1],
                                                s = document.querySelectorAll(".bundle__group");
                                            if (i) {
                                                var n = i.split(",");
                                                n.length > 1 &&
                                                    n.forEach((e, t) => {
                                                        var i = e.trim().toLowerCase().replace(/\s+/g, " ");
                                                        s[t].querySelectorAll(".bundle-variant-box").forEach(function (e) {
                                                            e.getAttribute("title").trim().toLowerCase().replace(/\s+/g, " ").includes(i) && e.click();
                                                        });
                                                    });
                                            }
                                            if ((t.preventDefault(), !theme.config.bpSmall && this.settings.stackedImages)) {
                                                var o = this.getThumbIndex(e);
                                                this.stackedScrollTo(o);
                                            }
                                        }.bind(this)
                                    ),
                                        e.addEventListener(
                                            "focus",
                                            function (t) {
                                                var i = this.getThumbIndex(e);
                                                theme.config.bpSmall ||
                                                    (this.settings.stackedImages
                                                        ? (this.container.querySelectorAll(a.photoThumbItem).forEach((e) => {
                                                              e.classList.remove(o);
                                                          }),
                                                          this.stackedScrollTo(i))
                                                        : this.flickity && this.flickity.goToSlide(i));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "keydown",
                                            function (e) {
                                                13 === e.keyCode && this.container.querySelector(a.currentSlide).focus();
                                            }.bind(this)
                                        );
                                });
                        },
                        stackedImagesInit: function () {
                            window.off(this.namespaceImages),
                                this.stackedImagePositions(),
                                this.inModal
                                    ? setTimeout(
                                          function () {
                                              this.stackedActive(this.settings.stackedCurrent);
                                          }.bind(this),
                                          1e3
                                      )
                                    : this.stackedActive(this.settings.stackedCurrent),
                                window.on("resize" + this.namespaceImages, theme.utils.debounce(200, this.stackedImagePositions.bind(this))),
                                window.on(
                                    "scroll" + this.namespaceImages,
                                    theme.utils.throttle(
                                        200,
                                        function () {
                                            var e = window.scrollY,
                                                t = this.settings.stackedImagePositions.reduce(function (t, i) {
                                                    return Math.abs(i - e) < Math.abs(t - e) ? i : t;
                                                }),
                                                i = this.settings.stackedImagePositions.indexOf(t);
                                            this.settings.stackedCurrent !== i && this.stackedActive(i);
                                        }.bind(this)
                                    )
                                );
                        },
                        stackedImagePositions: function () {
                            var e = [];
                            this.container.querySelectorAll(a.photo).forEach((t) => {
                                e.push(Math.round(t.offsetTop));
                            }),
                                (this.settings.stackedImagePositions = e);
                        },
                        stackedScrollTo: function (e) {
                            var t = this.container.querySelectorAll(a.photo)[e];
                            if (t) {
                                var i = t.offsetTop;
                                window.scroll({ top: i, behavior: "smooth" });
                            }
                        },
                        stackedActive: function (t) {
                            this.container.querySelectorAll(a.photoThumbItem).forEach((e) => {
                                e.classList.remove(o), e.classList.remove("is-active");
                            }),
                                console.log("hey", this);
                            var i = this.container.querySelectorAll(a.photoThumbItem)[t];
                            if ((i && (console, i.classList.add(o), (this.settings.currentSlideIndex = i.dataset.index)), this.settings.hasVideos)) {
                                this.stopVideos();
                                var s = this.container.querySelectorAll(a.photo)[t].querySelector(".product__video");
                                if (s) {
                                    var n = this._getVideoType(s),
                                        r = this._getVideoDivId(s);
                                    if ("youtube" === n) {
                                        if (e[r].videoPlayer && "sound" !== e[r].options.style) return void e[r].videoPlayer.playVideo();
                                    } else "mp4" === n && this.playMp4Video(r);
                                }
                            }
                            if (this.settings.has3d) {
                                var c = this.container.querySelectorAll(a.media);
                                c.length &&
                                    c.forEach((e) => {
                                        e.dispatchEvent(new CustomEvent("mediaHidden"));
                                    });
                                var l = this.container.querySelectorAll(a.photo)[t].querySelector(a.media);
                                l && l.dispatchEvent(new CustomEvent("mediaVisible"));
                            }
                            this.settings.stackedCurrent = t;
                        },
                        initSliders: function (e, t) {
                            this.destroyImageCarousels(), !theme.config.bpSmall && this.settings.stackedImages ? this.stackedImagesInit() : (this.flickity = new theme.Slideshow(this.mainSlider, e));
                        },
                        destroyImageCarousels: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        hideZoomOverlay: function (e) {
                            var t = this.container.querySelector(a.zoomButton);
                            e ? t && t.classList.add(s) : t && t.classList.remove(s);
                        },
                        openModalProduct: function () {
                            var e = !1;
                            this.settings.modalInit
                                ? ((e = !0), !theme.config.bpSmall && this.settings.stackedImages && this.stackedActive(0))
                                : ((this.blocksHolder = this.container.querySelector(a.blocksHolder)),
                                  fetch(this.blocksHolder.dataset.url)
                                      .then(function (e) {
                                          return e.text();
                                      })
                                      .then(
                                          function (e) {
                                              var t = new DOMParser().parseFromString(e, "text/html"),
                                                  i = t.querySelector(a.blocks);
                                              i.querySelectorAll("[id]").forEach((e) => {
                                                  var t = e.getAttribute("id");
                                                  e.setAttribute("id", t + "-modal");
                                                  var s = i.querySelector(`[for="${t}"]`);
                                                  s && s.setAttribute("for", t + "-modal");
                                                  var n = i.querySelector(`[aria-controls="${t}"]`);
                                                  n && n.setAttribute("aria-controls", t + "-modal");
                                              });
                                              var s = i.querySelector(a.formContainer).getAttribute("id");
                                              i.querySelectorAll("[form]").forEach((e) => {
                                                  e.setAttribute("form", s);
                                              }),
                                                  (this.blocksHolder.innerHTML = ""),
                                                  this.blocksHolder.append(i),
                                                  this.formSetup(),
                                                  this.updateModalProductInventory(),
                                                  Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                                  theme.collapsibles.init(this.container);
                                              var n = t.querySelectorAll("#MainContent .shopify-section:not(.shopify-section__product)");
                                              n.length && this.loadProductSections(n);
                                              var o = t.querySelector(".index-section.social-section");
                                              o && this.loadSocialSection(o),
                                                  window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                                                  theme.sections.loadSubSections(this.modal),
                                                  document.dispatchEvent(new CustomEvent("quickview:loaded", { detail: { productId: this.sectionId } })),
                                                  this.preImageSetup(),
                                                  this.initProductSlider(),
                                                  (this.settings.modalInit = !0);
                                          }.bind(this)
                                      )),
                                document.dispatchEvent(new CustomEvent("quickview:open", { detail: { initialized: e, productId: this.sectionId } }));
                        },
                        updateModalProductInventory: function () {
                            (window.inventories = window.inventories || {}),
                                this.container.querySelectorAll(".js-product-inventory-data").forEach((e) => {
                                    var t = e.dataset.productId;
                                    (window.inventories[t] = {}),
                                        e.querySelectorAll(".js-variant-inventory-data").forEach((e) => {
                                            window.inventories[t][e.dataset.id] = { quantity: e.dataset.quantity, policy: e.dataset.policy, incoming: e.dataset.incoming, next_incoming_date: e.dataset.date };
                                        });
                                });
                        },
                        closeModalProduct: function () {
                            this.stopVideos(), window.off(this.namespace);
                        },
                        loadProductSections: function (e) {
                            var t = document.querySelector("#ProductSectionsHolder-" + this.productId);
                            t && ((t.innerHTML = ""), t.append(...e), theme.collapsibles.init(t));
                        },
                        loadSocialSection: function (e) {
                            var t = document.querySelector("#SocialSectionHolder-" + this.productId);
                            t && t.replaceWith(e);
                        },
                        initModelViewerLibraries: function () {
                            var e = this.container.querySelectorAll(a.media);
                            e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
                        },
                        initShopifyXrLaunch: function () {
                            document.addEventListener(
                                "shopify_xr_launch",
                                function () {
                                    this.container.querySelector(a.productMediaWrapper + ":not(." + self.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                                }.bind(this)
                            );
                        },
                        customMediaListners: function () {
                            this.container.querySelectorAll(a.closeMedia).forEach((e) => {
                                e.addEventListener(
                                    "click",
                                    function () {
                                        if (this.settings.stackedImages) var e = this.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]');
                                        else e = this.mainSlider.querySelector(a.currentSlide);
                                        var t = e.querySelector(a.media);
                                        t && t.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                                    }.bind(this)
                                );
                            });
                            var e = this.container.querySelectorAll("model-viewer");
                            e.length &&
                                e.forEach((e) => {
                                    e.addEventListener(
                                        "shopify_model_viewer_ui_toggle_play",
                                        function (e) {
                                            this.mediaLoaded(e);
                                        }.bind(this)
                                    ),
                                        e.addEventListener(
                                            "shopify_model_viewer_ui_toggle_pause",
                                            function (e) {
                                                this.mediaUnloaded(e);
                                            }.bind(this)
                                        );
                                });
                        },
                        mediaLoaded: function (e) {
                            this.container.querySelectorAll(a.closeMedia).forEach((e) => {
                                e.classList.remove(s);
                            }),
                                this.flickity && this.flickity.setDraggable(!1);
                        },
                        mediaUnloaded: function (e) {
                            this.container.querySelectorAll(a.closeMedia).forEach((e) => {
                                e.classList.add(s);
                            }),
                                this.flickity && this.flickity.setDraggable(!0);
                        },
                        onUnload: function () {
                            window.off(this.namespace), this.container.off(this.namespace), this.destroyImageCarousels(), theme.ProductMedia.removeSectionModels(this.sectionId), AOS && AOS.refresh();
                        },
                    })),
                    r
                );
            })()),
            (theme.Blog = (function () {
                function e(e) {
                    this.tagFilters();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        tagFilters: function () {
                            var e = document.getElementById("BlogTagFilter");
                            e &&
                                e.addEventListener("change", function () {
                                    location.href = e.value;
                                });
                        },
                    })),
                    e
                );
            })()),
            (theme.HeaderSection = (function () {
                function e(e) {
                    this.initDrawers(),
                        theme.headerNav.init(),
                        theme.slideNav.init(),
                        Shopify &&
                            Shopify.designMode &&
                            (theme.sections.reinit("slideshow-section"),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("resize"));
                            }, 500));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        initDrawers: function () {
                            "drawer" === theme.settings.cartType && (document.body.classList.contains("template-cart") || new theme.CartDrawer());
                        },
                        onUnload: function () {
                            theme.headerNav.unload(), theme.slideNav.unload();
                        },
                    })),
                    e
                );
            })()),
            (theme.FooterSection = (function () {
                function e(e) {
                    (this.container = e), (this.localeDisclosure = null), (this.currencyDisclosure = null), theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 1e3 });
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            var e = this.container.querySelector("[data-disclosure-locale]"),
                                t = this.container.querySelector("[data-disclosure-currency]");
                            e && (this.localeDisclosure = new theme.Disclosure(e)), t && (this.currencyDisclosure = new theme.Disclosure(t));
                        },
                        onUnload: function () {
                            this.localeDisclosure && this.localeDisclosure.destroy(), this.currencyDisclosure && this.currencyDisclosure.destroy();
                        },
                    })),
                    e
                );
            })()),
            (theme.Collection = (function () {
                function e(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".collection-" + this.sectionId),
                        document.querySelector(".collection-hero") ? this.checkIfNeedReload() : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(),
                        this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            (this.container = this.container),
                                (this.sectionId = this.container.getAttribute("data-section-id")),
                                (this.sortSelect = document.querySelector("#SortBy")),
                                this.sortSelect && (this.sortSelect.on("change", this.onSortChange.bind(this)), (this.defaultSort = this.getDefaultSortValue())),
                                new theme.HoverProductGrid(this.container),
                                this.initParams(),
                                this.sortTags(),
                                this.bindBackButton();
                        },
                        initParams: function () {
                            if (((this.queryParams = {}), location.search.length))
                                for (var e, t = location.search.substr(1).split("&"), i = 0; i < t.length; i++) (e = t[i].split("=")).length > 1 && (this.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
                        },
                        getSortValue: function () {
                            return this.sortSelect.value || this.defaultSort;
                        },
                        getDefaultSortValue: function () {
                            return this.sortSelect.dataset.sortBy;
                        },
                        onSortChange: function () {
                            (this.queryParams.sort_by = this.getSortValue()), this.queryParams.page && delete this.queryParams.page;
                            var e = new URLSearchParams(Object.entries(this.queryParams));
                            window.location.search = e.toString();
                        },
                        sortTags: function () {
                            var e = document.getElementById("SortTags");
                            e &&
                                e.on("change", function (t) {
                                    location.href = e.value;
                                });
                        },
                        bindBackButton: function () {
                            window.off("popstate" + this.namespace),
                                window.on("popstate" + this.namespace, (e) => {
                                    if (e) {
                                        if (location.href.indexOf(location.pathname) >= 0) return !0;
                                        let t = new URL(window.location.href);
                                        theme.CollectionAjaxFilter(t, !1).then(() => {
                                            this.initPriceRange();
                                        });
                                    }
                                });
                        },
                        checkIfNeedReload: function () {
                            Shopify.designMode && theme.settings.overlayHeader && (document.querySelector(".header-wrapper").classList.contains("header-wrapper--overlay") || location.reload());
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            window.off(this.namespace), this.container.off(this.namespace);
                        },
                    })),
                    e
                );
            })()),
            (theme.CollectionFilter = (function () {
                var e = !1,
                    t = "tag--active";
                function i(e) {
                    (this.container = e), (this.sectionId = e.getAttribute("data-section-id")), (this.namespace = ".collection-filter-" + this.sectionId), this.init();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            document.querySelectorAll(".tag-list a").forEach((e) => {
                                e.on("click" + this.namespace, this.onTagClick.bind(this));
                            }),
                                document.querySelectorAll(".filter-form").forEach((e) => {
                                    e.addEventListener("input", this.onFormSubmit.bind(this));
                                }),
                                this.initPriceRange();
                        },
                        initPriceRange: function () {
                            document.querySelectorAll(".price-range").forEach((e) => new theme.PriceRange(e, { onChange: this.renderFromFormData.bind(this) }));
                        },
                        onTagClick: function (t) {
                            var i = t.currentTarget;
                            if (i.classList.contains("no-ajax") || (t.preventDefault(), e)) return;
                            e = !0;
                            let s = i.parentNode,
                                n = new URL(i.href);
                            this.renderActiveTag(s, i), this.startLoading(), this.renderCollectionPage(n.searchParams);
                        },
                        onFormSubmit: function (t) {
                            let i = t.target;
                            if (i.classList.contains("no-ajax") || (t.preventDefault(), e)) return;
                            e = !0;
                            let s = i.closest("li"),
                                n = i.closest("form"),
                                o = new FormData(n);
                            this.renderActiveTag(s, i), this.startLoading(), this.renderFromFormData(o);
                        },
                        renderCollectionPage: function (t) {
                            theme.CollectionAjaxFilter(t).then(() => {
                                (e = !1), this.initPriceRange();
                            });
                        },
                        renderFromFormData: function (e) {
                            let t = new URLSearchParams(e);
                            this.renderCollectionPage(t);
                        },
                        renderActiveTag: function (e, i) {
                            let s = e.querySelector(".tag__text");
                            if (e.classList.contains(t)) e.classList.remove(t);
                            else {
                                if (i.closest("li").classList.contains("tag--remove")) e.remove();
                                else {
                                    let n = document.createElement("li");
                                    n.classList.add("tag", "tag--remove");
                                    let o = document.createElement("a");
                                    o.classList.add("btn", "btn--small", "js-no-transition"), (o.innerText = s.innerText), n.appendChild(o);
                                    let a = document.querySelector(".tag-list--active-tags");
                                    a && a.append(n);
                                }
                                e.classList.add(t);
                            }
                        },
                        startLoading: function () {
                            document.querySelectorAll(".grid-product").forEach((e) => {
                                e.classList.add("unload");
                            });
                        },
                        forceReload: function () {
                            this.init();
                        },
                    })),
                    i
                );
            })()),
            (theme.CollectionAjaxFilter = function (e, t = !0) {
                let i = "CollectionFiltersSection",
                    s = "CollectionAjaxContent",
                    n = document.getElementById(i),
                    o = document.getElementById("CollectionSection");
                return new theme.AjaxRenderer({
                    sections: [
                        { sectionId: n.dataset.sectionId, nodeId: i },
                        { sectionId: o.dataset.sectionId, nodeId: s },
                    ],
                    preserveParams: ["sort_by"],
                })
                    .renderPage(window.location.pathname, e, t)
                    .then(() => {
                        theme.sections.reinit("collection-template"), theme.sections.reinit("collection-filter");
                        let e = document.getElementById(s);
                        theme.reinitProductGridItem(e), theme.QuickShopScreens.reInit(e);
                    });
            }),
            (theme.FeaturedCollection = (function () {
                var e = "overflow-scroller--disable-left",
                    t = "overflow-scroller--disable-right";
                function i(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.scrollWrap = this.container.querySelector("[data-pagination-wrapper]")),
                        (this.scrollArrows = this.container.querySelectorAll("[data-arrow]")),
                        (this.namespace = ".featured-collection-" + this.sectionId),
                        (this.options = { scrollable: this.container.dataset.scrollable, paginate: this.container.dataset.paginate });
                    var t = this.container.dataset.paginateBy,
                        i = this.container.dataset.collectionCount;
                    (this.settings = { url: this.container.dataset.collectionUrl, page: 1, pageCount: this.options.paginate ? Math.ceil(i / t) : 0, itemsToScroll: 3, gridItemWidth: this.container.dataset.gridItemWidth }),
                        (this.state = { isInit: !1, loading: !1, scrollerEnabled: !1, loadedAllProducts: !1, scrollable: this.options.scrollable, scrollInterval: null, scrollSpeed: 3 }),
                        (this.sizing = { scroller: 0, itemWidth: 0 }),
                        theme.promiseStylesheet().then(
                            function () {
                                theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) });
                            }.bind(this)
                        );
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            new theme.HoverProductGrid(this.container),
                                this.state.scrollable &&
                                    ((this.sizing = this.getScrollWidths()),
                                    window.on("resize" + this.namespace, theme.utils.debounce(200, this.handleResize.bind(this))),
                                    this.toggleScrollListener(this.state.scrollable),
                                    this.arrowListeners(this.state.scrollable),
                                    (this.state.isInit = !0));
                        },
                        reInit: function () {
                            new theme.HoverProductGrid(this.container), this.state.scrollable && ((this.sizing = this.getScrollWidths()), this.toggleScrollListener(this.state.scrollable)), theme.reinitProductGridItem();
                        },
                        loadingState: function (e) {
                            (this.state.loading = e), this.container.classList.toggle("collection-loading", e);
                        },
                        getScrollWidths: function () {
                            var e = this.scrollWrap.offsetWidth,
                                t = this.scrollWrap.scrollWidth,
                                i = this.scrollWrap.querySelector(".grid__item").offsetWidth;
                            return this.state.isInit || (t -= 200), t <= e && this.disableArrow(null, !0), { scroller: t, scrollSize: t - e, itemWidth: i };
                        },
                        handleResize: function () {
                            this.state.scrollable && (this.sizing = this.getScrollWidths()), this.toggleScrollListener(this.state.scrollable), this.arrowListeners(this.state.scrollable);
                        },
                        toggleScrollListener: function (e) {
                            e
                                ? this.state.scrollerEnabled || (this.scrollWrap.on("scroll" + this.namespace, theme.utils.throttle(250, this.scrollCheck.bind(this))), (this.state.scrollerEnabled = !0))
                                : (this.scrollWrap.off("scroll" + this.namespace), (this.state.scrollerEnabled = !1));
                        },
                        scrollCheck: function (e) {
                            if (this.state.loading) this.toggleScrollListener(!1);
                            else {
                                0 === this.sizing.scrollSize && (this.sizing = this.getScrollWidths());
                                var t = Math.floor(((e.currentTarget.scrollLeft ? e.currentTarget.scrollLeft : 0) / this.sizing.scrollSize) * 100);
                                this.sizing.scrollSize, this.options.paginate && !this.state.loadedAllProducts && t > 50 && this.getNewProducts(), t || (t = 0), this.disableArrow(t);
                            }
                        },
                        arrowListeners: function (e) {
                            this.scrollArrows.forEach((t) => {
                                t.off("click" + this.namespace), e ? (t.classList.remove("hide"), t.on("click" + this.namespace, this.arrowScroll.bind(this))) : t.classList.add("hide");
                            });
                        },
                        arrowScroll: function (e) {
                            var t = e.currentTarget.classList.contains("overflow-scroller__arrow--left") ? "left" : "right",
                                i = theme.config.bpSmall ? 1 : 2;
                            if ("mouseenter" === e.type)
                                this.state.scrollInterval = setInterval(
                                    function () {
                                        var e = this.scrollWrap.scrollLeft;
                                        this.scrollWrap.scrollLeft = "left" === t ? e - i : e + i;
                                    }.bind(this),
                                    this.state.scrollSpeed
                                );
                            else if ("mouseleave" === e.type) clearInterval(this.state.scrollInterval);
                            else if ("click" === e.type) {
                                clearInterval(this.state.scrollInterval);
                                var s = this.scrollWrap.scrollLeft,
                                    n = this.sizing.itemWidth * this.settings.itemsToScroll,
                                    o = "left" === t ? s - n : s + n;
                                this.scrollWrap.scroll({ left: o, behavior: "smooth" });
                            }
                            o <= 0 && this.disableArrow(o);
                        },
                        disableArrow: function (i, s) {
                            this.scrollArrows.forEach((n) => {
                                if ((n.classList.remove(t), n.classList.remove(e), s)) return n.classList.add(t), void n.classList.add(e);
                                i <= 10 ? n.classList.add(e) : i >= 96 && n.classList.add(t);
                            });
                        },
                        getNewProducts: function () {
                            this.loadingState(!0);
                            var e = this.settings.page + 1,
                                t = this.settings.gridItemWidth;
                            if (e > this.settings.pageCount) return this.loadingState(!1), void (this.state.loadedAllProducts = !0);
                            fetch(this.settings.url + "?page=" + e)
                                .then(function (e) {
                                    return e.text();
                                })
                                .then(
                                    function (e) {
                                        var i = new DOMParser().parseFromString(e, "text/html").querySelectorAll("[data-collection-container] .grid-product"),
                                            s = document.createDocumentFragment();
                                        i.forEach((e) => {
                                            e.classList.add(t), s.appendChild(e);
                                        }),
                                            this.container.querySelector("[data-product-container]").appendChild(s),
                                            this.ajaxSuccess();
                                    }.bind(this)
                                );
                        },
                        ajaxSuccess: function () {
                            this.loadingState(!1), (this.settings.page = this.settings.page + 1), this.reInit();
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onLoad: function () {
                            theme.QuickShopScreens.reInit(this.container);
                        },
                        onUnload: function () {
                            window.off(this.namespace), window.dispatchEvent(new Event("resize")), this.scrollWrap.off(this.namespace), theme.QuickShopScreens.unload(this.container);
                        },
                    })),
                    i
                );
            })()),
            (theme.Testimonials = (function () {
                var e = { adaptiveHeight: !1, avoidReflow: !0, pageDots: !0, prevNextButtons: !1, wrapAround: !0 };
                function t(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    (this.slideshow = e.querySelector("#Testimonials-" + t)),
                        this.slideshow &&
                            theme.promiseStylesheet().then(
                                function () {
                                    theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 600 });
                                }.bind(this)
                            );
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function (t, i) {
                            this.slideshow.dataset.count <= 3 && ((e.wrapAround = !1), (e.contain = !0)), (this.flickity = new theme.Slideshow(this.slideshow, e)), this.flickity.resize();
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = parseInt(this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId).dataset.index);
                            clearTimeout(this.timeout), this.flickity && "function" == typeof this.flickity.pause && (this.flickity.goToSlide(t), this.flickity.pause());
                        },
                        onBlockDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                    })),
                    t
                );
            })()),
            (theme.HeroAnimated = (function () {
                var e = "animated__slide--active",
                    t = "animated__slide--inactive";
                function i(e) {
                    this.container = e;
                    var t = e.dataset.count,
                        i = e.querySelector(".hero");
                    i && theme.loadImageSection(i),
                        (this.allImages = e.querySelectorAll(".animated__slide")),
                        (this.state = { activeIndex: 0 }),
                        1 !== t
                            ? (this.interval,
                              (this.intervalSpeed = e.dataset.interval),
                              (this.maxIndex = t - 1),
                              theme.promiseStylesheet().then(
                                  function () {
                                      theme.initWhenVisible({ element: this.container, callback: this.initInterval.bind(this) });
                                  }.bind(this)
                              ))
                            : this.setFades(!0);
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        initInterval: function () {
                            this.setFades(!0),
                                (this.interval = setInterval(
                                    function () {
                                        this.setFades();
                                    }.bind(this),
                                    this.intervalSpeed
                                ));
                        },
                        setFades: function (i) {
                            var s = this.state.activeIndex === this.maxIndex ? 0 : this.state.activeIndex + 1;
                            if ((i && (s = this.state.activeIndex), !i)) {
                                var n = this.allImages[this.state.activeIndex];
                                n.classList.remove(e), n.classList.add(t);
                            }
                            var o = this.allImages[s];
                            o.classList.remove(t), o.classList.add(e), (this.state.activeIndex = s);
                        },
                        onUnload: function () {
                            clearInterval(this.interval);
                        },
                    })),
                    i
                );
            })()),
            (theme.Maps = (function () {
                var e = null,
                    t = [],
                    i = {},
                    s = "[data-map]";
                function n(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.map = e.querySelector(s)),
                        (this.key = this.map.dataset.apiKey),
                        (i = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError }),
                        this.key && theme.initWhenVisible({ element: this.container, callback: this.prepMapApi.bind(this), threshold: 20 });
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode &&
                            (document.querySelectorAll('[data-section-type="map"]').forEach((e) => {
                                e.classList.add("map-section--load-error");
                            }),
                            document.querySelectorAll(s).forEach((e) => {
                                e.parentNode.removeChild(e);
                            }),
                            window.mapError(theme.strings.authError));
                    }),
                    (window.mapError = function (e) {
                        var t = document.createElement("div");
                        t.classList.add("map-section__error", "errors", "text-center"),
                            (t.innerHTML = e),
                            document.querySelectorAll(".map-section__overlay").forEach((e) => {
                                e.parentNode.prepend(t);
                            }),
                            document.querySelectorAll(".map-section__link").forEach((e) => {
                                e.classList.add("hide");
                            });
                    }),
                    (n.prototype = Object.assign({}, n.prototype, {
                        prepMapApi: function () {
                            if ("loaded" === e) this.createMap();
                            else if ((t.push(this), "loading" !== e && ((e = "loading"), void 0 === window.google || void 0 === window.google.maps))) {
                                var i = document.createElement("script");
                                (i.onload = function () {
                                    (e = "loaded"),
                                        t.forEach((e) => {
                                            e.createMap();
                                        });
                                }),
                                    (i.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                                    document.head.appendChild(i);
                            }
                        },
                        createMap: function () {
                            var e = this.map;
                            return (function (e) {
                                var t = new google.maps.Geocoder();
                                if (e) {
                                    var i = e.dataset.addressSetting;
                                    return new Promise((e, s) => {
                                        t.geocode({ address: i }, function (t, i) {
                                            i !== google.maps.GeocoderStatus.OK && s(i), e(t);
                                        });
                                    });
                                }
                            })(e)
                                .then(
                                    function (t) {
                                        var i = { zoom: 14, backgroundColor: "none", center: t[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                            s = (this.map = new google.maps.Map(e, i)),
                                            n = (this.center = s.getCenter());
                                        new google.maps.Marker({ map: s, position: s.getCenter() }),
                                            google.maps.event.addDomListener(
                                                window,
                                                "resize",
                                                theme.utils.debounce(250, function () {
                                                    google.maps.event.trigger(s, "resize"), s.setCenter(n), e.removeAttribute("style");
                                                })
                                            ),
                                            Shopify.designMode && window.AOS && AOS.refreshHard();
                                    }.bind(this)
                                )
                                .catch(function (e) {
                                    var t;
                                    switch (e) {
                                        case "ZERO_RESULTS":
                                            t = i.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            t = i.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            t = i.authError;
                                            break;
                                        default:
                                            t = i.addressError;
                                    }
                                    Shopify.designMode && window.mapError(t);
                                });
                        },
                        onUnload: function () {
                            0 !== this.map.length && google && google.maps && google.maps.event && google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    n
                );
            })()),
            (theme.SlideshowSection = (function () {
                function e(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    if (((this.slideshow = e.querySelector("#Slideshow-" + t)), (this.namespace = "." + t), (this.initialIndex = 0), this.slideshow)) {
                        var i = e.parentElement;
                        0 === [].indexOf.call(i.parentElement.children, i) ? this.init() : theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) });
                    }
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            var e = this.slideshow.querySelectorAll(".slideshow__slide");
                            if (
                                (this.container.hasAttribute("data-immediate-load") ? (this.slideshow.classList.remove("loading", "loading--delayed"), this.slideshow.classList.add("loaded")) : theme.loadImageSection(this.slideshow),
                                e.length > 1)
                            ) {
                                var t = {
                                    prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                                    pageDots: this.slideshow.hasAttribute("data-dots"),
                                    fade: !0,
                                    setGallerySize: !1,
                                    initialIndex: this.initialIndex,
                                    autoPlay: "true" === this.slideshow.dataset.autoplay && parseInt(this.slideshow.dataset.speed),
                                };
                                this.flickity = new theme.Slideshow(this.slideshow, t);
                            } else e[0].classList.add("is-selected");
                            this.container.hasAttribute("data-parallax") &&
                                this.container.querySelectorAll(".parallax-container").forEach(
                                    function (e, t) {
                                        new theme.Parallax(e, { namespace: this.namespace + "-parallax-" + t });
                                    }.bind(this)
                                );
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = parseInt(this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId).dataset.index);
                            this.flickity && "function" == typeof this.flickity.pause
                                ? (this.flickity.goToSlide(t), this.flickity.pause())
                                : ((this.initialIndex = t),
                                  setTimeout(
                                      function () {
                                          this.flickity && "function" == typeof this.flickity.pause && this.flickity.pause();
                                      }.bind(this),
                                      1e3
                                  ));
                        },
                        onBlockDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.args.autoPlay && this.flickity.play();
                        },
                    })),
                    e
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function e(e) {
                    this.container = e;
                    var t = this.container.getAttribute("data-section-id");
                    (this.cookieName = "newsletter-" + t),
                        e &&
                            "/challenge" !== window.location.pathname &&
                            ((this.data = { secondsBeforeShow: e.dataset.delaySeconds, daysBeforeReappear: e.dataset.delayDays, cookie: Cookies.get(this.cookieName), testMode: e.dataset.testMode }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal")),
                            (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(),
                            e.querySelector(".note--success")
                                ? this.closePopup(!0)
                                : (document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)), (this.data.cookie && "true" !== this.data.testMode) || this.initPopupDelay()));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        initPopupDelay: function () {
                            (Shopify && Shopify.designMode) ||
                                setTimeout(
                                    function () {
                                        this.modal.open();
                                    }.bind(this),
                                    1e3 * this.data.secondsBeforeShow
                                );
                        },
                        closePopup: function (e) {
                            if ("true" !== this.data.testMode) {
                                var t = e ? 200 : this.data.daysBeforeReappear;
                                Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
                            } else Cookies.remove(this.cookieName, { path: "/" });
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                    })),
                    e
                );
            })()),
            (theme.PasswordHeader = (function () {
                function e() {
                    this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            if (document.querySelector("#LoginModal")) {
                                var e = new theme.Modals("LoginModal", "login-modal", { focusIdOnOpen: "password", solid: !0 });
                                document.querySelectorAll(".errors").length && e.open();
                            }
                        },
                    })),
                    e
                );
            })()),
            (theme.Photoswipe = (function () {
                var e = ".photoswipe__image";
                function t(e, t) {
                    (this.container = e),
                        (this.sectionId = t),
                        (this.namespace = ".photoswipe-" + this.sectionId),
                        this.gallery,
                        this.images,
                        this.items,
                        (this.inSlideshow = !1),
                        e && "false" !== e.dataset.zoom && ("true" === e.dataset.hasSlideshow && (this.inSlideshow = !0), this.init());
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.container.querySelectorAll(".js-photoswipe__zoom").forEach((e) => {
                                e.on("click" + this.namespace, this.triggerClick.bind(this));
                            });
                        },
                        triggerClick: function (e) {
                            this.items = this.getImageData();
                            var t = this.inSlideshow ? this.container.querySelector(".is-selected") : e.currentTarget,
                                i = this.inSlideshow ? this.getChildIndex(t) : t.dataset.index;
                            this.initGallery(this.items, i);
                        },
                        getChildIndex: function (e) {
                            for (var t = 0; null != (e = e.previousSibling); ) t++;
                            return t + 1;
                        },
                        getImageData: function () {
                            this.images = this.inSlideshow ? this.container.querySelectorAll(".flickity-viewport " + e) : this.container.querySelectorAll(e);
                            var t = [];
                            return (
                                this.images.forEach((e) => {
                                    var i = { msrc: e.currentSrc || e.src, src: e.getAttribute("data-photoswipe-src"), w: e.getAttribute("data-photoswipe-width"), h: e.getAttribute("data-photoswipe-height"), el: e, initialZoomLevel: 0.5 };
                                    t.push(i);
                                }),
                                t
                            );
                        },
                        initGallery: function (e, t) {
                            var i = document.querySelectorAll(".pswp")[0];
                            (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                                allowPanToNext: !1,
                                captionEl: !1,
                                closeOnScroll: !1,
                                counterEl: !1,
                                history: !1,
                                index: t - 1,
                                pinchToClose: !1,
                                preloaderEl: !1,
                                scaleMode: "zoom",
                                shareEl: !1,
                                tapToToggleControls: !1,
                                getThumbBoundsFn: function (t) {
                                    var i = window.pageYOffset || document.documentElement.scrollTop,
                                        s = e[t].el.getBoundingClientRect();
                                    return { x: s.left, y: s.top + i, w: s.width };
                                },
                            })),
                                this.gallery.init(),
                                this.gallery.listen("afterChange", this.afterChange.bind(this));
                        },
                        afterChange: function () {
                            var e = this.gallery.getCurrentIndex();
                            this.container.dispatchEvent(new CustomEvent("photoswipe:afterChange", { detail: { index: e } }));
                        },
                    })),
                    t
                );
            })()),
            (theme.Recommendations = (function () {
                var e = { placeholder: ".product-recommendations-placeholder", sectionClass: " .product-recommendations", productResults: ".grid-product" };
                function t(t) {
                    (this.container = t),
                        (this.sectionId = t.getAttribute("data-section-id")),
                        (this.url = t.dataset.url),
                        (e.recommendations = "Recommendations-" + this.sectionId),
                        theme.initWhenVisible({ element: t, callback: this.init.bind(this), threshold: 500 });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            var t = document.getElementById(e.recommendations);
                            if (t && "false" !== t.dataset.enable) {
                                var i = t.dataset.productId,
                                    s = t.dataset.limit,
                                    n = this.url + "?section_id=product-recommendations&limit=" + s + "&product_id=" + i;
                                if (Shopify.designMode) {
                                    var o = t.querySelector(e.sectionClass);
                                    o && (o.innerHTML = "");
                                }
                                fetch(n)
                                    .then(function (e) {
                                        return e.text();
                                    })
                                    .then(
                                        function (i) {
                                            var s = new DOMParser().parseFromString(i, "text/html").querySelector(e.sectionClass),
                                                n = t.querySelector(e.placeholder);
                                            n &&
                                                ((n.innerHTML = ""),
                                                s
                                                    ? (n.appendChild(s),
                                                      theme.reinitProductGridItem(t),
                                                      document.dispatchEvent(new CustomEvent("recommendations:loaded", { detail: { section: t } })),
                                                      0 === s.querySelectorAll(e.productResults).length && this.container.classList.add("hide"))
                                                    : this.container.classList.add("hide"));
                                        }.bind(this)
                                    );
                            }
                        },
                    })),
                    t
                );
            })()),
            (theme.StoreAvailability = (function () {
                function e(e) {
                    (this.container = e), (this.baseUrl = e.dataset.baseUrl), (this.productTitle = e.dataset.productName);
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        updateContent: function (e) {
                            var t = this.baseUrl + "/variants/" + e + "/?section_id=store-availability",
                                i = this;
                            fetch(t)
                                .then(function (e) {
                                    return e.text();
                                })
                                .then(function (e) {
                                    if ("" !== e.trim()) {
                                        (i.container.innerHTML = e),
                                            (i.container.innerHTML = i.container.firstElementChild.innerHTML),
                                            i.container.querySelector(".js-drawer-open-availability") && (i.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability")),
                                            i.container.querySelector(".js-modal-open-availability") && (i.modal = new theme.Modals("StoreAvailabilityModal", "availability"));
                                        var t = i.container.querySelector("[data-availability-product-title]");
                                        t && (t.textContent = i.productTitle);
                                    } else this.container.innerHTML = "";
                                });
                        },
                    })),
                    e
                );
            })()),
            (theme.VideoSection = (function () {
                var e = ".video-parent-section";
                function t(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".video-" + this.sectionId),
                        this.videoObject,
                        theme.initWhenVisible({ element: this.container, callback: this.init.bind(this), threshold: 500 });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            var e = this.container.querySelector(".video-div");
                            if (e)
                                switch (e.dataset.type) {
                                    case "youtube":
                                        var t = e.dataset.videoId;
                                        this.initYoutubeVideo(t);
                                        break;
                                    case "vimeo":
                                        (t = e.dataset.videoId), this.initVimeoVideo(t);
                                        break;
                                    case "mp4":
                                        this.initMp4Video();
                                }
                        },
                        initYoutubeVideo: function (t) {
                            this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, { videoId: t, videoParent: e });
                        },
                        initVimeoVideo: function (t) {
                            this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, t, { videoParent: e });
                        },
                        initMp4Video: function () {
                            var t = "Mp4Video-" + this.sectionId,
                                i = document.getElementById(t),
                                s = i.closest(e);
                            if (i) {
                                s.classList.add("loaded");
                                var n = document.querySelector("#" + t).play();
                                void 0 !== n &&
                                    n
                                        .then(function () {})
                                        .catch(function () {
                                            i.setAttribute("controls", ""), s.classList.add("video-interactable");
                                        });
                            }
                        },
                        onUnload: function (e) {
                            e.target.id.replace("shopify-section-", ""), this.videoObject && "function" == typeof this.videoObject.destroy && this.videoObject.destroy();
                        },
                    })),
                    t
                );
            })()),
            (theme.isStorageSupported = function (e) {
                if (window.self !== window.top) return !1;
                var t,
                    i = "test";
                "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
                try {
                    return t.setItem(i, "1"), t.removeItem(i), !0;
                } catch (s) {
                    return !1;
                }
            }),
            (theme.reinitProductGridItem = function () {
                AOS && AOS.refreshHard(), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), theme.collapsibles.init();
            }),
            (theme.reviewAppLinkListener = function () {
                document.addEventListener("click", function (e) {
                    if (window.SPR) {
                        var t = e.target.parentNode,
                            i = null;
                        (t.matches(".spr-pagination-next") || t.matches(".spr-pagination-page")) && (i = t.closest(".spr-reviews")), i && i.scrollTo(0, 0);
                    }
                });
            }),
            (theme.checkForAnchorLink = function () {
                if (document && window.location.hash) {
                    var e = document.querySelector(window.location.hash);
                    e && window.scrollTo(0, e.offsetTop - 100);
                }
            }),
            (theme.init = function () {
                theme.QuickShopScreens.init(),
                    theme.rteInit(),
                    theme.articleImages(),
                    theme.collapsibles.init(),
                    "sticky" === theme.settings.cartType && new theme.StickyCart.init(),
                    theme.videoModal(),
                    window.addEventListener("pageshow", function (e) {
                        e.persisted && theme.refreshCart();
                    }),
                    performance && 2 === performance.navigation.type && theme.refreshCart();
            }),
            (theme.initSecondary = function () {
                    document.addEventListener("lazyloaded", function (e) {
                        var t = e.target;
                        t && t.parentNode.classList.add("loaded");
                    }),
                    theme.storeScrollPositionOnUnload(),
                    theme.reviewAppLinkListener(),
                    theme.checkForAnchorLink();
            }),
            (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
            (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
            (a = function () {
                if (
                    (theme.promiseStylesheet().then(function () {
                        theme.initSecondary(), document.dispatchEvent(new CustomEvent("page:loaded"));
                    }),
                    (theme.sections = new theme.Sections()),
                    theme.init(),
                    theme.settings.isCustomerTemplate && theme.customerTemplates(),
                    theme.sections.register("slideshow-section", theme.SlideshowSection),
                    theme.sections.register("header-section", theme.HeaderSection),
                    theme.sections.register("hero-animated", theme.HeroAnimated),
                    theme.sections.register("video-section", theme.VideoSection),
                    theme.sections.register("product", theme.Product),
                    theme.sections.register("product-recommendations", theme.Recommendations),
                    theme.sections.register("password-header", theme.PasswordHeader),
                    theme.sections.register("product-template", theme.Product),
                    theme.sections.register("featured-collection", theme.FeaturedCollection),
                    theme.sections.register("collection-template", theme.Collection),
                    theme.sections.register("collection-filter", theme.CollectionFilter),
                    theme.sections.register("testimonials", theme.Testimonials),
                    theme.sections.register("newsletter-popup", theme.NewsletterPopup),
                    theme.sections.register("map", theme.Maps),
                    theme.sections.register("blog", theme.Blog),
                    theme.sections.register("footer-section", theme.FooterSection),
                    theme.sections.register("store-availability", theme.StoreAvailability),
                    document.body.classList.contains("template-cart"))
                ) {
                    var e = document.getElementById("CartPageForm");
                    e && new theme.CartForm(e);
                }
                theme.pageTransitions();
            }),
            "loading" != document.readyState ? a() : document.addEventListener("DOMContentLoaded", a);
    })();
